// tslint:disable
/**
 * Climate Compass API
 * This document decribes the REST API that manages Climate Compass functionality. It allows user to administrate emission coefficients and emission coefficients version...  The endpoints are checked for suitable inputs like valid and not already used emission coefficients and emission coefficients versions and provided with suitable error messages depending on the operation.  # Error Responses All error reponses will contain the same fields. One of those fields is called \"errorCode\". This will contain a unique identifier of the error category. ## Generic web-server error responses All listed end-points can return generic web-server errorCodes, that are not registered for the specific end-points. These errorCodes fall into the 2 categories: 400 Climate Compass errors and 500 errors. Please refer to standard HTTP status code documentation for a full overview. Some examples of generic errorCodes, not defined on each end-point but still possible to get are:  ### Climate Compass error responses * `BAD_REQUEST` (400) * `UNAUTHORIZED` (401) * `FORBIDDEN` (403) * `NOT_FOUND` (404) * `REQUEST_TIMEOUT` (408) * `UNSUPPORTED_MEDIA_TYPE` (415)  ### Server error responses * `INTERNAL_SERVER_ERROR` (500) * `SERVICE_UNAVAILABLE` (503) * `HTTP_VERSION_NET_SUPPORTED` (505)  ## Application specific error codes Each endpoint may result in an application specific errorCode. Most of those errorCodes are related to an http status code of type BAD_REQUEST but are not limited to that http status code. For each errorCode a message will also be present. The message template for each application specific errorCode is listed here to avoid repeating it for each endpoint (responses section).  * `INTERNAL_ERROR` Internal server error. Check the internal logs for logToken with id: \'%s\'.  * `VERSION_NOT_FOUND` Version deosn\'t exist.  * `EMISSION_COEFFICIENT_NOT_FOUND` Emission Coefficient not found.  * `CALCULATION_NOT_FOUND` Calculation not found.  * `FILE_NOT_READABLE` File not readeble  * `FILE_NOT_FOUND` File not found  * `ALLOWED_NUMBER_FILES_EXCEEDED` Allowed number of files exceeded  * `ELEMENT_ALREADY_EXIST` cannot create as element already exist  * `ITEM_NOT_FOUND` the request item does not exist 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccessIndividualInfo
 */
export interface AccessIndividualInfo {
    /**
     * primay key of item
     * @type {number}
     * @memberof AccessIndividualInfo
     */
    id?: number;
    /**
     * mit id ident of individual at vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof AccessIndividualInfo
     */
    rid?: string;
    /**
     * name of individual at vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof AccessIndividualInfo
     */
    name?: string;
    /**
     * email of individual at vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof AccessIndividualInfo
     */
    email?: string;
    /**
     * pogo ident of individual at vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof AccessIndividualInfo
     */
    pogoIdent?: string;
    /**
     * status of 3. part individual access e.g. ACCESS_PENDING means that 3. part has request access (trin 2)
     * @type {string}
     * @memberof AccessIndividualInfo
     */
    status?: AccessIndividualInfoStatusEnum;
    /**
     * has third party revoked the access given
     * @type {boolean}
     * @memberof AccessIndividualInfo
     */
    revoked?: boolean;
    /**
     * When has the third party revoked the access that was given
     * @type {string}
     * @memberof AccessIndividualInfo
     */
    revokedDate?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AccessIndividualInfoStatusEnum {
    PENDING = 'ACCESS_PENDING',
    GRANTED = 'ACCESS_GRANTED',
    REVOKED = 'ACCESS_REVOKED',
    DELETED = 'ACCESS_DELETED',
    REJECTED = 'ACCESS_REJECTED'
}

/**
 * 
 * @export
 * @interface AccessInfo
 */
export interface AccessInfo {
    /**
     * id
     * @type {number}
     * @memberof AccessInfo
     */
    id?: number;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof AccessInfo
     */
    vatId: string;
    /**
     * 
     * @type {string}
     * @memberof AccessInfo
     */
    contantPersonName: string;
    /**
     * Email of contact person of third party given access to
     * @type {string}
     * @memberof AccessInfo
     */
    contactPersonEmail: string;
    /**
     * name for the company you have given access to
     * @type {string}
     * @memberof AccessInfo
     */
    companyName?: string;
    /**
     * expire Date in ISO 8601 format. When will the access expire
     * @type {string}
     * @memberof AccessInfo
     */
    expireDate?: string;
    /**
     * has third party revoked the access given
     * @type {boolean}
     * @memberof AccessInfo
     */
    revoked?: boolean;
    /**
     * When has the third party revoked the access that was given
     * @type {string}
     * @memberof AccessInfo
     */
    revokedDate?: string;
    /**
     * has a message/toast been shown about the revokion
     * @type {boolean}
     * @memberof AccessInfo
     */
    revokedMessageShown?: boolean;
    /**
     * The calculations infos that we grant access to
     * @type {Array<CalculationInfo>}
     * @memberof AccessInfo
     */
    calculationInfoList?: Array<CalculationInfo>;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof AccessInfo
     */
    vatIdSource?: string;
    /**
     * name of the person if cpr login or company name you gives 3. party access
     * @type {string}
     * @memberof AccessInfo
     */
    nameSource?: string;
    /**
     * is cpr user or company
     * @type {boolean}
     * @memberof AccessInfo
     */
    privateSource?: boolean;
    /**
     * list of individuals for 3. party access
     * @type {Array<AccessIndividualInfo>}
     * @memberof AccessInfo
     */
    individualsAccessInfoList?: Array<AccessIndividualInfo>;
    /**
     * name of the person if cpr login or company name you gives 3. party access
     * @type {string}
     * @memberof AccessInfo
     */
    companyNameSource?: string;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * id
     * @type {number}
     * @memberof Address
     */
    id?: number;
    /**
     * street name in address
     * @type {string}
     * @memberof Address
     */
    street: string;
    /**
     * House number from
     * @type {number}
     * @memberof Address
     */
    houseNumberFrom?: number;
    /**
     * House number to
     * @type {number}
     * @memberof Address
     */
    houseNumberto?: number;
    /**
     * Letter from
     * @type {string}
     * @memberof Address
     */
    letterFrom?: string;
    /**
     * Letter to
     * @type {string}
     * @memberof Address
     */
    letterTo?: string;
    /**
     * building floor
     * @type {string}
     * @memberof Address
     */
    floor?: string;
    /**
     * Door which side
     * @type {string}
     * @memberof Address
     */
    sideDoor?: string;
    /**
     * Place name
     * @type {string}
     * @memberof Address
     */
    placeName?: string;
    /**
     * postal code in address
     * @type {string}
     * @memberof Address
     */
    zipCode: string;
    /**
     * city in address
     * @type {string}
     * @memberof Address
     */
    city: string;
    /**
     * Calculation foreign key
     * @type {number}
     * @memberof Address
     */
    calculationId?: number;
    /**
     * Indicates if address is active on calculation
     * @type {boolean}
     * @memberof Address
     */
    calculationActive?: boolean;
    /**
     * A state/region of an adress
     * @type {string}
     * @memberof Address
     */
    state?: string;
    /**
     * smartystreet validation e.g. Verified
     * @type {string}
     * @memberof Address
     */
    verificationStatus?: string;
    /**
     * optional message e.g. detailed validation message, front end can use it if they want
     * @type {string}
     * @memberof Address
     */
    verificationMessage?: string;
    /**
     * Address as a oneliner
     * @type {string}
     * @memberof Address
     */
    freetext?: string;
}
/**
 * 
 * @export
 * @interface AddressInfo
 */
export interface AddressInfo {
    /**
     * 
     * @type {Address}
     * @memberof AddressInfo
     */
    address?: Address;
    /**
     * 2-char code for country
     * @type {string}
     * @memberof AddressInfo
     */
    country?: string;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof AddressInfo
     */
    vatNo?: string;
    /**
     * Company Name.
     * @type {string}
     * @memberof AddressInfo
     */
    companyName?: string;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof AddressInfo
     */
    calculationVatNo?: string;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof AddressInfo
     */
    calculationBehalfOfVatNo?: string;
}
/**
 * 
 * @export
 * @interface Addresses
 */
export interface Addresses {
    /**
     * 
     * @type {Array<Address>}
     * @memberof Addresses
     */
    addresses?: Array<Address>;
}
/**
 * 
 * @export
 * @interface BusinessCode
 */
export interface BusinessCode {
    /**
     * 
     * @type {number}
     * @memberof BusinessCode
     */
    id?: number;
    /**
     * 6 ciffer number for branchekode
     * @type {string}
     * @memberof BusinessCode
     */
    branchekode: string;
    /**
     * daninsh text explining branchekode
     * @type {string}
     * @memberof BusinessCode
     */
    branchetekst?: string;
}
/**
 * 
 * @export
 * @interface Calculate
 */
export interface Calculate {
    /**
     * If present - which entry to owerwrite with new values - else id will be created
     * @type {number}
     * @memberof Calculate
     */
    id?: number;
    /**
     * id of the calculation where this part calculation belongs
     * @type {number}
     * @memberof Calculate
     */
    calculationId: number;
    /**
     * Subgrouping Id
     * @type {number}
     * @memberof Calculate
     */
    subgroupingId: number;
    /**
     * coefficient group of Emission Coefficient.
     * @type {string}
     * @memberof Calculate
     */
    coeficientGroup?: string;
    /**
     * All field values must be present for a calculation line.
     * @type {Array<FieldValue>}
     * @memberof Calculate
     */
    fieldValues: Array<FieldValue>;
    /**
     * 2-char code for country
     * @type {string}
     * @memberof Calculate
     */
    usedCountryCode?: string;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof Calculate
     */
    thirdpartyVatNo?: string;
    /**
     * who did create vatno or cprnr
     * @type {string}
     * @memberof Calculate
     */
    createdBy?: string;
    /**
     * when was the record created
     * @type {string}
     * @memberof Calculate
     */
    createdTime?: string;
    /**
     * who did the update vatno or cprnr
     * @type {string}
     * @memberof Calculate
     */
    updatedBy?: string;
    /**
     * when was the record updated
     * @type {string}
     * @memberof Calculate
     */
    updatedTime?: string;
    /**
     * the state of the line
     * @type {string}
     * @memberof Calculate
     */
    state?: string;
    /**
     * optional parameter
     * @type {number}
     * @memberof Calculate
     */
    year?: number;
    /**
     * optional parameter
     * @type {number}
     * @memberof Calculate
     */
    version?: number;
    /**
     * optional ref to emission coefficient
     * @type {number}
     * @memberof Calculate
     */
    emissionCoefficentId?: number;
    /**
     * optional ref to emission coefficient
     * @type {number}
     * @memberof Calculate
     */
    emissionCoefficentMasterId?: number;
    /**
     * optional ref to emission coefficient
     * @type {string}
     * @memberof Calculate
     */
    emissionCoefficentMasterKey?: string;
    /**
     * important info from backend
     * @type {string}
     * @memberof Calculate
     */
    information?: string;
    /**
     * 
     * @type {FileMessages}
     * @memberof Calculate
     */
    files?: FileMessages;
    /**
     * e.g if obsulute units
     * @type {boolean}
     * @memberof Calculate
     */
    showWarning?: boolean;
    /**
     * is base module or full climatecompass
     * @type {boolean}
     * @memberof Calculate
     */
    isBasisModule?: boolean;
}
/**
 * 
 * @export
 * @interface CalculatedResult
 */
export interface CalculatedResult {
    /**
     * calculation id
     * @type {number}
     * @memberof CalculatedResult
     */
    calculationId?: number;
    /**
     * total value calculated for scope1
     * @type {number}
     * @memberof CalculatedResult
     */
    scope1Result?: number;
    /**
     * total value calculated for scope2
     * @type {number}
     * @memberof CalculatedResult
     */
    scope2Result?: number;
    /**
     * total value calculated for scope3
     * @type {number}
     * @memberof CalculatedResult
     */
    scope3Result?: number;
    /**
     * total value calculated for scope1+scop2+scope3
     * @type {number}
     * @memberof CalculatedResult
     */
    scopesResult?: number;
    /**
     * total value calculated for outside scope
     * @type {number}
     * @memberof CalculatedResult
     */
    outsideScopeResult?: number;
    /**
     * share in total result
     * @type {number}
     * @memberof CalculatedResult
     */
    shareInTotal?: number;
    /**
     * total value calculated
     * @type {number}
     * @memberof CalculatedResult
     */
    totalResult?: number;
}
/**
 * 
 * @export
 * @interface Calculation
 */
export interface Calculation {
    /**
     * calculation id
     * @type {number}
     * @memberof Calculation
     */
    id?: number;
    /**
     * Calculation state.
     * @type {string}
     * @memberof Calculation
     */
    state: CalculationStateEnum;
    /**
     * If no one else in the company shall be able to see the calculation.
     * @type {boolean}
     * @memberof Calculation
     */
    privateCalculation?: boolean;
    /**
     * Unique ID number
     * @type {string}
     * @memberof Calculation
     */
    contactPersonRID: string;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof Calculation
     */
    vatNo: string;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof Calculation
     */
    behalfOfVatNo?: string;
    /**
     * Comment to be used for result calculation
     * @type {string}
     * @memberof Calculation
     */
    resultComment?: string;
    /**
     * 
     * @type {CalculationPurpose}
     * @memberof Calculation
     */
    calculationPurpose: CalculationPurpose;
    /**
     * 
     * @type {CompanyInformation}
     * @memberof Calculation
     */
    companyInformation?: CompanyInformation;
    /**
     * 
     * @type {Version}
     * @memberof Calculation
     */
    emissionCoefficientsVersion?: Version;
    /**
     * If RFI for aeroplane shall be used or not
     * @type {boolean}
     * @memberof Calculation
     */
    rfi: boolean;
    /**
     * If Environment declaration shall be used for electricity or not.
     * @type {boolean}
     * @memberof Calculation
     */
    electricityEnvironmentDeclaration: boolean;
    /**
     * who did create vatno or cprnr
     * @type {string}
     * @memberof Calculation
     */
    createdBy?: string;
    /**
     * when was the record created
     * @type {string}
     * @memberof Calculation
     */
    createdTime?: string;
    /**
     * who did the update vatno or cprnr
     * @type {string}
     * @memberof Calculation
     */
    updatedBy?: string;
    /**
     * when was the record updated
     * @type {string}
     * @memberof Calculation
     */
    updatedTime?: string;
    /**
     * a performance variable, contains companyName
     * @type {string}
     * @memberof Calculation
     */
    createdByName?: string;
    /**
     * a performance variable, contains companyName
     * @type {string}
     * @memberof Calculation
     */
    updatedByName?: string;
    /**
     * When copy do we include files
     * @type {boolean}
     * @memberof Calculation
     */
    copyFiles?: boolean;
    /**
     * helper to FE to indicate if info is shown
     * @type {boolean}
     * @memberof Calculation
     */
    showCreatedBy?: boolean;
    /**
     * helper to FE to indicate if info is shown
     * @type {boolean}
     * @memberof Calculation
     */
    showUpdatedBy?: boolean;
    /**
     * forecast id
     * @type {number}
     * @memberof Calculation
     */
    forecastId?: number;
    /**
     * 
     * @type {Version}
     * @memberof Calculation
     */
    availableEmissionCoefficientsVersion?: Version;
    /**
     * is calculation used as basis for a forecast. Note many forecast can have samme source calculation
     * @type {boolean}
     * @memberof Calculation
     */
    isBasisForForecast?: boolean;
    /**
     * true if has at least one calculation line, else false
     * @type {boolean}
     * @memberof Calculation
     */
    hasCalculationLines?: boolean;
    /**
     * parent id (reference from a copied calculation to the original)
     * @type {number}
     * @memberof Calculation
     */
    parentId?: number;
    /**
     * Is calculation used in a comparison, if so specific conditions can occour
     * @type {boolean}
     * @memberof Calculation
     */
    isUsedInComparison?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum CalculationStateEnum {
    Draft = 'draft',
    Finished = 'finished',
    Archived = 'archived',
    Deleted = 'deleted',
    Readonly = 'readonly',
    Duplicated = 'duplicated',
    FinishedDuplicated = 'finished_duplicated',
    Forecasted = 'forecasted',
    Importing = 'importing'
}

/**
 * used for anonymous users
 * @export
 * @interface CalculationAndLines
 */
export interface CalculationAndLines {
    /**
     * 
     * @type {Calculation}
     * @memberof CalculationAndLines
     */
    calculation?: Calculation;
    /**
     * 
     * @type {Array<Calculate>}
     * @memberof CalculationAndLines
     */
    lines?: Array<Calculate>;
}
/**
 * 
 * @export
 * @interface CalculationFull
 */
export interface CalculationFull {
    /**
     * 
     * @type {Calculation}
     * @memberof CalculationFull
     */
    calculation?: Calculation;
    /**
     * 
     * @type {Array<Calculate>}
     * @memberof CalculationFull
     */
    lines?: Array<Calculate>;
    /**
     * 
     * @type {Array<TotalsInfo>}
     * @memberof CalculationFull
     */
    totals?: Array<TotalsInfo>;
}
/**
 * 
 * @export
 * @interface CalculationInfo
 */
export interface CalculationInfo {
    /**
     * calculation id
     * @type {number}
     * @memberof CalculationInfo
     */
    calculationId?: number;
    /**
     * 
     * @type {string}
     * @memberof CalculationInfo
     */
    calculationName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CalculationInfo
     */
    isKladde?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CalculationInfo
     */
    contactpersonRid?: string;
}
/**
 * 
 * @export
 * @interface CalculationPurpose
 */
export interface CalculationPurpose {
    /**
     * Name of calculation.
     * @type {string}
     * @memberof CalculationPurpose
     */
    name: string;
    /**
     * Purpose of the calculation
     * @type {string}
     * @memberof CalculationPurpose
     */
    purpose: CalculationPurposePurposeEnum;
    /**
     * Start Date in ISO 8601 format.
     * @type {string}
     * @memberof CalculationPurpose
     */
    startDate: string;
    /**
     * enddata and start date can be different year so we need all data, so 5 or 10 chars are legal
     * @type {string}
     * @memberof CalculationPurpose
     */
    endDate: string;
    /**
     * Comment to be related to this calculation
     * @type {string}
     * @memberof CalculationPurpose
     */
    comment?: string;
    /**
     * 
     * @type {Array<BusinessCode>}
     * @memberof CalculationPurpose
     */
    businessCodes?: Array<BusinessCode>;
}

/**
    * @export
    * @enum {string}
    */
export enum CalculationPurposePurposeEnum {
    RealClimateFootprint = 'realClimateFootprint',
    CO2reducingMeasures = 'CO2reducingMeasures',
    Forecast = 'forecast',
    StudyOrOther = 'studyOrOther'
}

/**
 * 
 * @export
 * @interface Calculations
 */
export interface Calculations {
    /**
     * 
     * @type {Array<Calculation>}
     * @memberof Calculations
     */
    calculations?: Array<Calculation>;
}
/**
 * 
 * @export
 * @interface CategoryInfo
 */
export interface CategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    categoryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    contentfulId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryInfo
     */
    selected?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CategoryInfo
     */
    scope3_percent?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    category_type?: CategoryInfoCategoryTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CategoryInfoCategoryTypeEnum {
    UPSTREAM = 'UPSTREAM',
    DOWNSTREAM = 'DOWNSTREAM'
}

/**
 * 
 * @export
 * @interface CategoryResult
 */
export interface CategoryResult {
    /**
     * Category name
     * @type {string}
     * @memberof CategoryResult
     */
    categoryName?: string;
    /**
     * Total scope 3 emission in the category
     * @type {number}
     * @memberof CategoryResult
     */
    categoryResult?: number;
}
/**
 * 
 * @export
 * @interface CategoryResultsScope3
 */
export interface CategoryResultsScope3 {
    /**
     * which year is the values for
     * @type {number}
     * @memberof CategoryResultsScope3
     */
    year?: number;
    /**
     * 
     * @type {Array<CategoryResult>}
     * @memberof CategoryResultsScope3
     */
    results?: Array<CategoryResult>;
    /**
     * 
     * @type {number}
     * @memberof CategoryResultsScope3
     */
    scope3resultsOutsideCategories?: number;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * Company vat number
     * @type {string}
     * @memberof Company
     */
    vatNo?: string;
    /**
     * Company name
     * @type {string}
     * @memberof Company
     */
    name?: string;
    /**
     * 
     * @type {Array<BusinessCode>}
     * @memberof Company
     */
    businessCodes?: Array<BusinessCode>;
}
/**
 * 
 * @export
 * @interface CompanyInformation
 */
export interface CompanyInformation {
    /**
     * id
     * @type {number}
     * @memberof CompanyInformation
     */
    id?: number;
    /**
     * ISO 3166 2 letter country codes
     * @type {string}
     * @memberof CompanyInformation
     */
    country?: string;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof CompanyInformation
     */
    vatNo?: string;
    /**
     * Company Name.
     * @type {string}
     * @memberof CompanyInformation
     */
    companyName?: string;
    /**
     * 
     * @type {Array<ProductionUnit>}
     * @memberof CompanyInformation
     */
    productionUnits?: Array<ProductionUnit>;
    /**
     * Number of employees in the given period.
     * @type {number}
     * @memberof CompanyInformation
     */
    numberOfEmployees?: number;
    /**
     * Turnover in millions of Danish Kroner.
     * @type {number}
     * @memberof CompanyInformation
     */
    turnover?: number;
    /**
     * Amount of m2 building area
     * @type {number}
     * @memberof CompanyInformation
     */
    buildingSquareMeterArea?: number;
}
/**
 * 
 * @export
 * @interface CompareFilterObject
 */
export interface CompareFilterObject {
    /**
     * name of the filter currently used
     * @type {string}
     * @memberof CompareFilterObject
     */
    compareType?: CompareFilterObjectCompareTypeEnum;
    /**
     * id of dropdown
     * @type {number}
     * @memberof CompareFilterObject
     */
    dropdownId?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CompareFilterObjectCompareTypeEnum {
    SCOPE = 'SCOPE',
    CATEGORY = 'CATEGORY',
    TRANSPORT = 'TRANSPORT',
    ENERGY = 'ENERGY',
    PROCUREMENT = 'PROCUREMENT',
    TRASH = 'TRASH',
    PRODUCTS = 'PRODUCTS'
}

/**
 * 
 * @export
 * @interface CompareMetaObject
 */
export interface CompareMetaObject {
    /**
     * compare meta data object id
     * @type {number}
     * @memberof CompareMetaObject
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompareMetaObject
     */
    vatNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CompareMetaObject
     */
    thirdPartyVatNo?: string;
    /**
     * name of comparison
     * @type {string}
     * @memberof CompareMetaObject
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompareMetaObject
     */
    description?: string;
    /**
     * 
     * @type {Array<CompareFilterObject>}
     * @memberof CompareMetaObject
     */
    compareFilters?: Array<CompareFilterObject>;
    /**
     * 
     * @type {Array<CalculationInfo>}
     * @memberof CompareMetaObject
     */
    calculations?: Array<CalculationInfo>;
    /**
     * if just one of the calculation lines in the calculations has monitary items return true else false
     * @type {boolean}
     * @memberof CompareMetaObject
     */
    hasMonetaryCalculations?: boolean;
    /**
     * EMF year exist for startdato but not used or startdato after non-fremskrevet (valid) EMF year
     * @type {boolean}
     * @memberof CompareMetaObject
     */
    hasDifferentEMF?: boolean;
}
/**
 * 
 * @export
 * @interface ComparisonObject
 */
export interface ComparisonObject {
    /**
     * 
     * @type {CompareMetaObject}
     * @memberof ComparisonObject
     */
    comparisonMetadata?: CompareMetaObject;
    /**
     * the calculation with lines
     * @type {Array<CalculationFull>}
     * @memberof ComparisonObject
     */
    calculations?: Array<CalculationFull>;
}
/**
 * 
 * @export
 * @interface ComparisonOverviewInfo
 */
export interface ComparisonOverviewInfo {
    /**
     * comparisonMetadataObjectd
     * @type {number}
     * @memberof ComparisonOverviewInfo
     */
    id?: number;
    /**
     * name of comparison
     * @type {string}
     * @memberof ComparisonOverviewInfo
     */
    name?: string;
    /**
     * self explaiantionary
     * @type {string}
     * @memberof ComparisonOverviewInfo
     */
    description?: string;
    /**
     * 
     * @type {Array<CalculationInfo>}
     * @memberof ComparisonOverviewInfo
     */
    calculationNames?: Array<CalculationInfo>;
}
/**
 * 
 * @export
 * @interface ConfigValue
 */
export interface ConfigValue {
    /**
     * value to set for configuration property
     * @type {string}
     * @memberof ConfigValue
     */
    configuration?: string;
}
/**
 * 
 * @export
 * @interface ContactPerson
 */
export interface ContactPerson {
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof ContactPerson
     */
    vatNo: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    lastName: string;
    /**
     * Email of contact person for a given organisation
     * @type {string}
     * @memberof ContactPerson
     */
    email: string;
    /**
     * News letter registration
     * @type {boolean}
     * @memberof ContactPerson
     */
    newsEnabled?: boolean;
    /**
     * accept terms registration
     * @type {boolean}
     * @memberof ContactPerson
     */
    termsEnabled?: boolean;
    /**
     * person datao terms registration
     * @type {boolean}
     * @memberof ContactPerson
     */
    personTermsEnabled?: boolean;
    /**
     * Email of company only used if not private user
     * @type {string}
     * @memberof ContactPerson
     */
    corporateEmail?: string;
    /**
     * Number of contentful keys to be shown in Toast
     * @type {string}
     * @memberof ContactPerson
     */
    messages?: string;
    /**
     * Country of residence for the contact person
     * @type {string}
     * @memberof ContactPerson
     */
    country: string;
}
/**
 * 
 * @export
 * @interface Countries
 */
export interface Countries {
    /**
     * 
     * @type {Array<Country>}
     * @memberof Countries
     */
    countries?: Array<Country>;
}
/**
 * 
 * @export
 * @interface CountriesWithLocalizedNames
 */
export interface CountriesWithLocalizedNames {
    /**
     * 
     * @type {Array<CountryWithLocalizedNames>}
     * @memberof CountriesWithLocalizedNames
     */
    countries?: Array<CountryWithLocalizedNames>;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * Country code (ISO code)
     * @type {string}
     * @memberof Country
     */
    code?: string;
    /**
     * Country name
     * @type {string}
     * @memberof Country
     */
    name?: string;
    /**
     * key to contentful
     * @type {string}
     * @memberof Country
     */
    contentfulId?: string;
}
/**
 * Localized name for a country
 * @export
 * @interface CountryNameLocal
 */
export interface CountryNameLocal {
    /**
     * Language code (ISO code)
     * @type {string}
     * @memberof CountryNameLocal
     */
    languageCode?: string;
    /**
     * Country name the language specified by languageCode
     * @type {string}
     * @memberof CountryNameLocal
     */
    name?: string;
}
/**
 * Extra country type conforming with country data from PoGo land service localized names for da/en
 * @export
 * @interface CountryWithLocalizedNames
 */
export interface CountryWithLocalizedNames {
    /**
     * Country code (ISO code)
     * @type {string}
     * @memberof CountryWithLocalizedNames
     */
    code?: string;
    /**
     * 
     * @type {Array<CountryNameLocal>}
     * @memberof CountryWithLocalizedNames
     */
    names?: Array<CountryNameLocal>;
}
/**
 * 
 * @export
 * @interface EMFMasterdata
 */
export interface EMFMasterdata {
    /**
     * 
     * @type {number}
     * @memberof EMFMasterdata
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EMFMasterdata
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof EMFMasterdata
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof EMFMasterdata
     */
    subgroupingId?: number;
    /**
     * 
     * @type {string}
     * @memberof EMFMasterdata
     */
    unit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EMFMasterdata
     */
    hasOwnEMC?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EMFMasterdata
     */
    subgroupingName?: string;
    /**
     * 
     * @type {string}
     * @memberof EMFMasterdata
     */
    information?: string;
    /**
     * 
     * @type {number}
     * @memberof EMFMasterdata
     */
    scope1?: number;
    /**
     * 
     * @type {number}
     * @memberof EMFMasterdata
     */
    scope2?: number;
    /**
     * 
     * @type {number}
     * @memberof EMFMasterdata
     */
    scope3?: number;
    /**
     * 
     * @type {number}
     * @memberof EMFMasterdata
     */
    outsideScope?: number;
}
/**
 * 
 * @export
 * @interface ESGResult
 */
export interface ESGResult {
    /**
     * Samlet scope 1 udledning (i Ton CO2e)
     * @type {number}
     * @memberof ESGResult
     */
    scope1Total?: number;
    /**
     * Samlet scope 2 udledning (i Ton CO2e)
     * @type {number}
     * @memberof ESGResult
     */
    scope2Total?: number;
    /**
     * Samlet scope 3 udledning (i Ton CO2e)
     * @type {number}
     * @memberof ESGResult
     */
    scope3Total?: number;
    /**
     * Scope 1 og 2 total
     * @type {number}
     * @memberof ESGResult
     */
    scope1and2Total?: number;
    /**
     * CO2 intensitet (i Ton Co2e / mio. DKK)
     * @type {number}
     * @memberof ESGResult
     */
    co2Intensity?: number;
    /**
     * CO2 intensitet for scope 1 og 2 (i Ton Co2e / mio. DKK)
     * @type {number}
     * @memberof ESGResult
     */
    co2IntensityScope1and2?: number;
    /**
     * energiforbrug i MWh
     * @type {number}
     * @memberof ESGResult
     */
    energyTotal?: number;
    /**
     * Fossilt energiforbrug [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    energyConsumptionFossilSourcesResult?: number;
    /**
     * Fossilt energiforbrug [i %]
     * @type {number}
     * @memberof ESGResult
     */
    energyConsumptionFossilSourcesPct?: number;
    /**
     * Nukleart energiforbrug [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    energyConsumptionNuclearSourcesResult?: number;
    /**
     * Nukleart energiforbrug [i %]
     * @type {number}
     * @memberof ESGResult
     */
    energyConsumptionNuclearSourcesPct?: number;
    /**
     * Vedvarende energiforbrug [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    energyConsumptionRenewableSourcesResult?: number;
    /**
     * Vedvarende energiforbrug [i %]
     * @type {number}
     * @memberof ESGResult
     */
    energyConsumptionRenewableSourcesPct?: number;
    /**
     * energiforbrug div med omsætning
     * @type {number}
     * @memberof ESGResult
     */
    energyIntensity?: number;
    /**
     * Samlet vandforbrug (i m3)
     * @type {number}
     * @memberof ESGResult
     */
    waterConsumption?: number;
    /**
     * omsætning
     * @type {number}
     * @memberof ESGResult
     */
    turnover?: number;
    /**
     * Total mængde af affald [i Ton]
     * @type {number}
     * @memberof ESGResult
     */
    wasteTotal?: number;
    /**
     * Mængde af farligt affald [i Ton]
     * @type {number}
     * @memberof ESGResult
     */
    wasteHazardousTotal?: number;
    /**
     * Andel af farligt affald (i %)
     * @type {number}
     * @memberof ESGResult
     */
    wasteHazardousPercentage?: number;
    /**
     * Mængde af genanvendt affald [i Ton]
     * @type {number}
     * @memberof ESGResult
     */
    wasteRecycledTotal?: number;
    /**
     * Andel af genanvendt affald (i %)
     * @type {number}
     * @memberof ESGResult
     */
    wasteRecycledPercentage?: number;
    /**
     * Total mængde elektricitet [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    electricityTotal?: number;
    /**
     * Total mængde vedvarende elektricitet [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    electricityRenewableTotal?: number;
    /**
     * Total mængde ikke-vedvarende elektricitet [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    electricityNonRenewableTotal?: number;
    /**
     * Total mængde brændsel [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    fuelTotal?: number;
    /**
     * Total mængde vedvarende brændsel [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    fuelRenewableTotal?: number;
    /**
     * Total mængde ikke-vedvarende brændsel [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    fuelNonRenewableTotal?: number;
    /**
     * Total mængde fjernvarme [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    districtHeatingTotal?: number;
    /**
     * Total mængde vedvarende fjernvarme [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    districtHeatingRenewableTotal?: number;
    /**
     * Total mængde ikke-vedvarende fjernvarme [i MWh]
     * @type {number}
     * @memberof ESGResult
     */
    districtHeatingNonRenewableTotal?: number;
    /**
     * Indicate of energy result is missing to do missing conversion item
     * @type {boolean}
     * @memberof ESGResult
     */
    mustUpdateDueToESGEnergy?: boolean;
    /**
     * Indicate of electricity is missing to do missong conversion item
     * @type {boolean}
     * @memberof ESGResult
     */
    mustUpdateDueToESGElectricity?: boolean;
    /**
     * For old own lines (and energy) the ESG will not be corrent until the shares of fossil, nuclear, sustainable to specified. Return true if ESG result will be wrong
     * @type {boolean}
     * @memberof ESGResult
     */
    isMissingESGDataEnergy?: boolean;
    /**
     * For old own lines (and el) the ESG will not be corrent until the shares of fossil, nuclear, sustainable to specified. Return true if ESG result will be wrong
     * @type {boolean}
     * @memberof ESGResult
     */
    isMissingESGDataElectricity?: boolean;
    /**
     * For old own lines (and el) the ESG must be converted to legal unit
     * @type {boolean}
     * @memberof ESGResult
     */
    isIllegalESGUnitElectricity?: boolean;
}
/**
 * 
 * @export
 * @interface EmissionCoefficient
 */
export interface EmissionCoefficient {
    /**
     * 
     * @type {Version}
     * @memberof EmissionCoefficient
     */
    version: Version;
    /**
     * A key for Emission Coefficient.
     * @type {string}
     * @memberof EmissionCoefficient
     */
    key: string;
    /**
     * Id of Sub grouping of Emission Coefficient.
     * @type {number}
     * @memberof EmissionCoefficient
     */
    subgroupingId?: number;
    /**
     * coefficient group of Emission Coefficient.
     * @type {string}
     * @memberof EmissionCoefficient
     */
    coefficientGroup?: string;
    /**
     * description of Emission Coefficient.
     * @type {string}
     * @memberof EmissionCoefficient
     */
    parameter?: string;
    /**
     * description2 of Emission Coefficient.
     * @type {string}
     * @memberof EmissionCoefficient
     */
    parameter2?: string;
    /**
     * unit of Emission Coefficient value.
     * @type {string}
     * @memberof EmissionCoefficient
     */
    unit: string;
    /**
     * emission coefficioent
     * @type {number}
     * @memberof EmissionCoefficient
     */
    scope1?: number;
    /**
     * emission coefficioent
     * @type {number}
     * @memberof EmissionCoefficient
     */
    scope2?: number;
    /**
     * emission coefficioent
     * @type {number}
     * @memberof EmissionCoefficient
     */
    scope3?: number;
    /**
     * emission coefficioent
     * @type {number}
     * @memberof EmissionCoefficient
     */
    outsideScope?: number;
    /**
     * source of Emission Coefficient.
     * @type {string}
     * @memberof EmissionCoefficient
     */
    source: string;
    /**
     * If true, it is not public available.
     * @type {boolean}
     * @memberof EmissionCoefficient
     */
    secret: boolean;
    /**
     * 
     * @type {Country}
     * @memberof EmissionCoefficient
     */
    land?: Country;
    /**
     * from excel import sheet
     * @type {string}
     * @memberof EmissionCoefficient
     */
    importGroup?: string;
    /**
     * real or fremskrevet
     * @type {boolean}
     * @memberof EmissionCoefficient
     */
    actual?: boolean;
}
/**
 * 
 * @export
 * @interface EmissionCoefficientOverview
 */
export interface EmissionCoefficientOverview {
    /**
     * year of emc
     * @type {number}
     * @memberof EmissionCoefficientOverview
     */
    year?: number;
    /**
     * version of emc
     * @type {number}
     * @memberof EmissionCoefficientOverview
     */
    version?: number;
    /**
     * which conuntry
     * @type {string}
     * @memberof EmissionCoefficientOverview
     */
    countryCode?: string;
    /**
     * how many EMC in total
     * @type {number}
     * @memberof EmissionCoefficientOverview
     */
    numberEMC?: number;
    /**
     * how many of the EMC has a mapping til EMC masterdata
     * @type {number}
     * @memberof EmissionCoefficientOverview
     */
    numberEMCMapped?: number;
    /**
     * is real EMC numbers or forcasted
     * @type {boolean}
     * @memberof EmissionCoefficientOverview
     */
    actual?: boolean;
}
/**
 * 
 * @export
 * @interface EmissionCoefficientsInfo
 */
export interface EmissionCoefficientsInfo {
    /**
     * 
     * @type {Array<EmissionCoefficient>}
     * @memberof EmissionCoefficientsInfo
     */
    emmisionCoefficients?: Array<EmissionCoefficient>;
    /**
     * all or partial
     * @type {boolean}
     * @memberof EmissionCoefficientsInfo
     */
    all?: boolean;
}
/**
 * 
 * @export
 * @interface ExcelMappingdata
 */
export interface ExcelMappingdata {
    /**
     * 
     * @type {number}
     * @memberof ExcelMappingdata
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ExcelMappingdata
     */
    emfId?: number;
    /**
     * 
     * @type {string}
     * @memberof ExcelMappingdata
     */
    emfKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcelMappingdata
     */
    excelKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcelMappingdata
     */
    emfDesc?: string;
}
/**
 * 
 * @export
 * @interface ExcelRow
 */
export interface ExcelRow {
    /**
     * 
     * @type {string}
     * @memberof ExcelRow
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcelRow
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcelRow
     */
    mainCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcelRow
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcelRow
     */
    parameter1?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcelRow
     */
    parameter2?: string;
    /**
     * 
     * @type {number}
     * @memberof ExcelRow
     */
    scope1?: number;
    /**
     * 
     * @type {number}
     * @memberof ExcelRow
     */
    scope2?: number;
    /**
     * 
     * @type {number}
     * @memberof ExcelRow
     */
    scope3?: number;
    /**
     * 
     * @type {number}
     * @memberof ExcelRow
     */
    outsideScope?: number;
}
/**
 * 
 * @export
 * @interface Field
 */
export interface Field {
    /**
     * field id
     * @type {number}
     * @memberof Field
     */
    id: number;
    /**
     * Name of field.
     * @type {string}
     * @memberof Field
     */
    name: string;
    /**
     * contentful id for text message in contentful
     * @type {string}
     * @memberof Field
     */
    contentfulId: string;
    /**
     * regualur expression describing boundry of input
     * @type {string}
     * @memberof Field
     */
    validationRegex?: string;
    /**
     * minimum acceptable value
     * @type {number}
     * @memberof Field
     */
    minimumValue?: number;
    /**
     * maximum acceptable value
     * @type {number}
     * @memberof Field
     */
    maximumValue?: number;
    /**
     * The maximum accuracy allowed
     * @type {number}
     * @memberof Field
     */
    step?: number;
    /**
     * required or optional filed
     * @type {boolean}
     * @memberof Field
     */
    required?: boolean;
    /**
     * value type for field
     * @type {string}
     * @memberof Field
     */
    valueType: string;
    /**
     * If valueType is DROPDOWN - possible values in dropdown.
     * @type {Array<FieldEnum>}
     * @memberof Field
     */
    possibleValues?: Array<FieldEnum>;
    /**
     * is field enabled in input section
     * @type {boolean}
     * @memberof Field
     */
    isEnabled?: boolean;
    /**
     * Position used for frontend
     * @type {number}
     * @memberof Field
     */
    calculatorSlotPosition?: number;
    /**
     * Index used for backend calculation
     * @type {number}
     * @memberof Field
     */
    fieldsOrder?: number;
}
/**
 * 
 * @export
 * @interface FieldEnum
 */
export interface FieldEnum {
    /**
     * fieldEnum id
     * @type {number}
     * @memberof FieldEnum
     */
    id: number;
    /**
     * Contain unit
     * @type {string}
     * @memberof FieldEnum
     */
    name: string;
    /**
     * Boolean value for disabling field
     * @type {boolean}
     * @memberof FieldEnum
     */
    disabled: boolean;
    /**
     * If this possible value results in an restriction on another dropdown
     * @type {Array<FieldEnum>}
     * @memberof FieldEnum
     */
    dependent?: Array<FieldEnum>;
    /**
     * is more than one item in dropdown one could be default
     * @type {boolean}
     * @memberof FieldEnum
     */
    isDefault?: boolean;
    /**
     * key to contentful id with translaation
     * @type {string}
     * @memberof FieldEnum
     */
    contentfulId?: string;
    /**
     * name not NLS translated
     * @type {string}
     * @memberof FieldEnum
     */
    orgName?: string;
}
/**
 * 
 * @export
 * @interface FieldValue
 */
export interface FieldValue {
    /**
     * field id
     * @type {number}
     * @memberof FieldValue
     */
    id: number;
    /**
     * Can contain any value. Even Date, numbers and integers
     * @type {string}
     * @memberof FieldValue
     */
    value: string;
    /**
     * key to contentful
     * @type {string}
     * @memberof FieldValue
     */
    contentfulId?: string;
    /**
     * id of value if dropdown else null
     * @type {number}
     * @memberof FieldValue
     */
    fieldEnumId?: number;
}
/**
 * 
 * @export
 * @interface FileMessage
 */
export interface FileMessage {
    /**
     * File id
     * @type {number}
     * @memberof FileMessage
     */
    fileId?: number;
    /**
     * calculation id
     * @type {number}
     * @memberof FileMessage
     */
    calculationId?: number;
    /**
     * File name
     * @type {string}
     * @memberof FileMessage
     */
    fileName?: string;
    /**
     * File type of file returned
     * @type {string}
     * @memberof FileMessage
     */
    fileType?: string;
}
/**
 * 
 * @export
 * @interface FileMessages
 */
export interface FileMessages {
    /**
     * 
     * @type {Array<FileMessage>}
     * @memberof FileMessages
     */
    files?: Array<FileMessage>;
}
/**
 * 
 * @export
 * @interface FileResource
 */
export interface FileResource {
    /**
     * File id
     * @type {number}
     * @memberof FileResource
     */
    fileId?: number;
    /**
     * Base64-encoded contents of the file
     * @type {string}
     * @memberof FileResource
     */
    data?: string;
}
/**
 * 
 * @export
 * @interface ForecastHeaderInfo
 */
export interface ForecastHeaderInfo {
    /**
     * forecast id
     * @type {number}
     * @memberof ForecastHeaderInfo
     */
    forecastId?: number;
}
/**
 * 
 * @export
 * @interface ForecastHeaderResult
 */
export interface ForecastHeaderResult {
    /**
     * forecast id
     * @type {number}
     * @memberof ForecastHeaderResult
     */
    forcastId?: number;
}
/**
 * 
 * @export
 * @interface ForecastInfo
 */
export interface ForecastInfo {
    /**
     * forecast id
     * @type {number}
     * @memberof ForecastInfo
     */
    forecastId?: number;
    /**
     * forecast name
     * @type {string}
     * @memberof ForecastInfo
     */
    name?: string;
    /**
     * calculation id
     * @type {number}
     * @memberof ForecastInfo
     */
    sourceCalculationId?: number;
    /**
     * calculation name
     * @type {string}
     * @memberof ForecastInfo
     */
    sourceCalculationName?: string;
    /**
     * calculation EMF year
     * @type {number}
     * @memberof ForecastInfo
     */
    sourceCalculationYear?: number;
    /**
     * expected growth each year
     * @type {number}
     * @memberof ForecastInfo
     */
    growthRate?: number;
    /**
     * type of growth (linear, expontential).
     * @type {string}
     * @memberof ForecastInfo
     */
    growthType?: ForecastInfoGrowthTypeEnum;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof ForecastInfo
     */
    thirdpartyVatNo?: string;
    /**
     * criteria eg. Scopes, Hovedkategori, Indkøb
     * @type {string}
     * @memberof ForecastInfo
     */
    graphDisplayCriteria?: string;
    /**
     * layout attributes (true or false)
     * @type {boolean}
     * @memberof ForecastInfo
     */
    graphDisplayScope1?: boolean;
    /**
     * layout attributes (true or false)
     * @type {boolean}
     * @memberof ForecastInfo
     */
    graphDisplayScope2?: boolean;
    /**
     * layout attributes (true or false)
     * @type {boolean}
     * @memberof ForecastInfo
     */
    graphDisplayScope3?: boolean;
    /**
     * if false the backend is still building the forecast calculations
     * @type {boolean}
     * @memberof ForecastInfo
     */
    isCreationCompleted?: boolean;
    /**
     * message from backend typicall if errors
     * @type {string}
     * @memberof ForecastInfo
     */
    message?: string;
    /**
     * messagestatus typically set if errors
     * @type {string}
     * @memberof ForecastInfo
     */
    messageStatus?: ForecastInfoMessageStatusEnum;
    /**
     * true if thread creating calculations has started
     * @type {boolean}
     * @memberof ForecastInfo
     */
    isCreationStarted?: boolean;
    /**
     * when was the record created
     * @type {string}
     * @memberof ForecastInfo
     */
    createdTime?: string;
    /**
     * 
     * @type {Array<ReductionInfo>}
     * @memberof ForecastInfo
     */
    reductionInfos?: Array<ReductionInfo>;
    /**
     * basisyear for calculation e.g if period of calculation spans multiple years
     * @type {number}
     * @memberof ForecastInfo
     */
    basisYear?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ForecastInfoGrowthTypeEnum {
    Linear = 'linear',
    Exponential = 'exponential'
}
/**
    * @export
    * @enum {string}
    */
export enum ForecastInfoMessageStatusEnum {
    ERRORDB = 'ERROR_DB',
    ERRORGENERAL = 'ERROR_GENERAL',
    UNKNOWN = 'UNKNOWN'
}

/**
 * 
 * @export
 * @interface ForecastResults
 */
export interface ForecastResults {
    /**
     * 
     * @type {Array<GroupingCalculatedResults>}
     * @memberof ForecastResults
     */
    calculations?: Array<GroupingCalculatedResults>;
    /**
     * 
     * @type {ForecastInfo}
     * @memberof ForecastResults
     */
    forcastHeader?: ForecastInfo;
}
/**
 * 
 * @export
 * @interface Forecasts
 */
export interface Forecasts {
    /**
     * 
     * @type {Array<ForecastInfo>}
     * @memberof Forecasts
     */
    forecasts?: Array<ForecastInfo>;
}
/**
 * 
 * @export
 * @interface GHGCalculatedResult
 */
export interface GHGCalculatedResult {
    /**
     * calculation id
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    calculationId?: number;
    /**
     * total value calculated for scope1
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    scope1Result?: number;
    /**
     * total value calculated for scope2
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    scope2Result?: number;
    /**
     * total value calculated for scope3
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    scope3Result?: number;
    /**
     * share score1 in total result
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    shareScope1InTotal?: number;
    /**
     * share score2 in total result
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    shareScope2InTotal?: number;
    /**
     * share score3 in total result
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    shareScope3InTotal?: number;
    /**
     * total value calculated for outside scope
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    outsideScopeResult?: number;
    /**
     * share outside scope in total result
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    shareOutsideScopeInTotal?: number;
    /**
     * total value calculated for scope1+scope2+scope3
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    totalResult?: number;
    /**
     * total value calculated for scope1
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    scope1ResultOtherDeclaration?: number;
    /**
     * total value calculated for scope2
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    scope2ResultOtherDeclaration?: number;
    /**
     * total value calculated for scope3
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    scope3ResultOtherDeclaration?: number;
    /**
     * total value calculated for outside scope
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    outsideScopeResultOtherDeclaration?: number;
    /**
     * total value calculated for scope1+scope2+scope3
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    totalResultOtherDeclaration?: number;
    /**
     * first part of scope3Result (=scope3ResultReduction + scope3ResultNoReduction)
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    scope3ResultReduction?: number;
    /**
     * second part of scope3Result (=scope3ResultReduction + scope3ResultNoReduction)
     * @type {number}
     * @memberof GHGCalculatedResult
     */
    scope3ResultNoReduction?: number;
}
/**
 * 
 * @export
 * @interface GroupingCalculatedResult
 */
export interface GroupingCalculatedResult {
    /**
     * id of the grouping (subject)
     * @type {number}
     * @memberof GroupingCalculatedResult
     */
    groupingId?: number;
    /**
     * Grouping (Subject) name
     * @type {string}
     * @memberof GroupingCalculatedResult
     */
    groupingName?: string;
    /**
     * 
     * @type {CalculatedResult}
     * @memberof GroupingCalculatedResult
     */
    calculatedResult?: CalculatedResult;
    /**
     * 
     * @type {Array<MergedSubgroupingCalculatedResult>}
     * @memberof GroupingCalculatedResult
     */
    mergedSubgroupingsCalculated?: Array<MergedSubgroupingCalculatedResult>;
    /**
     * 
     * @type {Array<PurchaseGroupingCalculatedResult>}
     * @memberof GroupingCalculatedResult
     */
    purchaseGroupingCalculatedResults?: Array<PurchaseGroupingCalculatedResult>;
    /**
     * 
     * @type {Array<SubgroupingCalculatedResult>}
     * @memberof GroupingCalculatedResult
     */
    subgroupingsCalculated?: Array<SubgroupingCalculatedResult>;
}
/**
 * 
 * @export
 * @interface GroupingCalculatedResults
 */
export interface GroupingCalculatedResults {
    /**
     * calculation id
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    calculationId?: number;
    /**
     * 
     * @type {GHGCalculatedResult}
     * @memberof GroupingCalculatedResults
     */
    ghgCalculatedResult?: GHGCalculatedResult;
    /**
     * the year the results are for
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    year?: number;
    /**
     * total value calculated for all calculations
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    totalResult?: number;
    /**
     * total value calculated for all scores1+score2+score3
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    scoresTotalResult?: number;
    /**
     * total value calculated for all scores1+score2+score3 using the non-selected electricity declaration mode
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    scoresTotalResultOtherDeclaration?: number;
    /**
     * total value calculated for all outside scores
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    outsideScoresTotalResult?: number;
    /**
     * total value calculated for all outside scores using the non-selected electricity declaration mode
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    outsideScoresTotalResultOtherDeclaration?: number;
    /**
     * total value on number of employees
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    resultOnNumberOfEmployees?: number;
    /**
     * total value on turnover
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    resultOnTurnover?: number;
    /**
     * total value number of square meters
     * @type {number}
     * @memberof GroupingCalculatedResults
     */
    resultOnNumberOfSquareMeters?: number;
    /**
     * Emission Coefficent method, if RFI should be taken into account when calculating aeroplane
     * @type {boolean}
     * @memberof GroupingCalculatedResults
     */
    electricityEnvironmentDeclaration?: boolean;
    /**
     * Emission Coefficent method for electricity, true for \"El\" and false for \"Miljø\"
     * @type {boolean}
     * @memberof GroupingCalculatedResults
     */
    rfi?: boolean;
    /**
     * 
     * @type {Array<GroupingCalculatedResult>}
     * @memberof GroupingCalculatedResults
     */
    groupingResults?: Array<GroupingCalculatedResult>;
    /**
     * 
     * @type {Array<CategoryResult>}
     * @memberof GroupingCalculatedResults
     */
    categoryResults?: Array<CategoryResult>;
    /**
     * 
     * @type {ESGResult}
     * @memberof GroupingCalculatedResults
     */
    esgResult?: ESGResult;
    /**
     * is calculation based on forecasted or real EMC data
     * @type {boolean}
     * @memberof GroupingCalculatedResults
     */
    isForecastedData?: boolean;
    /**
     * which subgroups must be changed
     * @type {Array<number>}
     * @memberof GroupingCalculatedResults
     */
    subgroupWarnings?: Array<number>;
}
/**
 * 
 * @export
 * @interface ImportPermission
 */
export interface ImportPermission {
    /**
     * 
     * @type {boolean}
     * @memberof ImportPermission
     */
    canImport?: boolean;
}
/**
 * 
 * @export
 * @interface ImportValidationError
 */
export interface ImportValidationError {
    /**
     * 
     * @type {string}
     * @memberof ImportValidationError
     */
    errorType?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportValidationError
     */
    header?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportValidationError
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportValidationError
     */
    import_file_id?: number;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * JSON string representation of Calculate object
     * @type {string}
     * @memberof InlineObject
     */
    calculation?: string;
    /**
     * 
     * @type {any}
     * @memberof InlineObject
     */
    file1?: any;
    /**
     * 
     * @type {any}
     * @memberof InlineObject
     */
    file2?: any;
    /**
     * 
     * @type {any}
     * @memberof InlineObject
     */
    file3?: any;
}
/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 
     * @type {any}
     * @memberof InlineObject1
     */
    file?: any;
    /**
     * sheetName, if empty validates all sheets
     * @type {string}
     * @memberof InlineObject1
     */
    sheetName?: string;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * 
     * @type {any}
     * @memberof InlineObject2
     */
    file?: any;
    /**
     * name of the sheet to import
     * @type {string}
     * @memberof InlineObject2
     */
    sheetName?: string;
}
/**
 * 
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
    /**
     * 
     * @type {any}
     * @memberof InlineObject3
     */
    file?: any;
    /**
     * year
     * @type {string}
     * @memberof InlineObject3
     */
    year?: string;
    /**
     * what version to import into
     * @type {string}
     * @memberof InlineObject3
     */
    version?: string;
    /**
     * is a forecast 1 = true else false
     * @type {string}
     * @memberof InlineObject3
     */
    isForecast?: string;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * 
     * @type {any}
     * @memberof InlineObject4
     */
    file?: any;
    /**
     * if true ignores scope values and always import if possible
     * @type {boolean}
     * @memberof InlineObject4
     */
    ignoreScopeValues?: boolean;
}
/**
 * 
 * @export
 * @interface LocalizedValidationError
 */
export interface LocalizedValidationError {
    /**
     * 
     * @type {string}
     * @memberof LocalizedValidationError
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizedValidationError
     */
    textKey?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LocalizedValidationError
     */
    parameters?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface MergedSubgroupingCalculatedResult
 */
export interface MergedSubgroupingCalculatedResult {
    /**
     * Merged Subgrouping name
     * @type {string}
     * @memberof MergedSubgroupingCalculatedResult
     */
    mergedSubgroupingName?: string;
    /**
     * 
     * @type {CalculatedResult}
     * @memberof MergedSubgroupingCalculatedResult
     */
    calculatedResult?: CalculatedResult;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * The path on which the request was received.
     * @type {string}
     * @memberof ModelError
     */
    path: string;
    /**
     * A message describing the cause of the error.
     * @type {string}
     * @memberof ModelError
     */
    message: string;
    /**
     * When the error ocurred in date-time.
     * @type {string}
     * @memberof ModelError
     */
    timestamp: string;
    /**
     * A unique identifier of the error category.
     * @type {string}
     * @memberof ModelError
     */
    errorCode: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ModelError
     */
    replacementText?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface News
 */
export interface News {
    /**
     * id
     * @type {number}
     * @memberof News
     */
    id?: number;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof News
     */
    vatId: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    contentfulId?: string;
    /**
     * the date the user has marked the news as seen
     * @type {string}
     * @memberof News
     */
    hasSeen?: string;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * key
     * @type {number}
     * @memberof Notification
     */
    id?: number;
    /**
     * vat nr
     * @type {string}
     * @memberof Notification
     */
    vatNo?: string;
    /**
     * user ident
     * @type {string}
     * @memberof Notification
     */
    rid?: string;
    /**
     * id of string in external system
     * @type {string}
     * @memberof Notification
     */
    contentfulId?: string;
    /**
     * Key value structure with parameters used for contentful strings
     * @type {string}
     * @memberof Notification
     */
    parameterMap?: string;
    /**
     * type of information
     * @type {string}
     * @memberof Notification
     */
    type?: string;
    /**
     * when was the notification created
     * @type {string}
     * @memberof Notification
     */
    createdTime?: string;
    /**
     * more detailed type of item
     * @type {string}
     * @memberof Notification
     */
    status?: string;
}
/**
 * 
 * @export
 * @interface PendingImportFile
 */
export interface PendingImportFile {
    /**
     * 
     * @type {string}
     * @memberof PendingImportFile
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingImportFile
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingImportFile
     */
    rid?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingImportFile
     */
    vatNo?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingImportFile
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingImportFile
     */
    json_calculation_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingImportFile
     */
    calculation_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingImportFile
     */
    createdTime?: string;
}
/**
 * 
 * @export
 * @interface ProductionUnit
 */
export interface ProductionUnit {
    /**
     * id
     * @type {number}
     * @memberof ProductionUnit
     */
    id?: number;
    /**
     * Production Unit number
     * @type {string}
     * @memberof ProductionUnit
     */
    pNumber: string;
    /**
     * 
     * @type {Address}
     * @memberof ProductionUnit
     */
    address: Address;
    /**
     * for foreign addresses with might not have a real prod unit. In these cases mark it with a flag
     * @type {boolean}
     * @memberof ProductionUnit
     */
    fake?: boolean;
}
/**
 * 
 * @export
 * @interface ProductionUnits
 */
export interface ProductionUnits {
    /**
     * 
     * @type {Array<ProductionUnit>}
     * @memberof ProductionUnits
     */
    productionUnits?: Array<ProductionUnit>;
}
/**
 * 
 * @export
 * @interface PurchaseGroupingCalculatedResult
 */
export interface PurchaseGroupingCalculatedResult {
    /**
     * Merged Subgrouping name
     * @type {string}
     * @memberof PurchaseGroupingCalculatedResult
     */
    mergedSubgroupingName?: string;
    /**
     * 
     * @type {CalculatedResult}
     * @memberof PurchaseGroupingCalculatedResult
     */
    calculatedResult?: CalculatedResult;
    /**
     * 
     * @type {Array<MergedSubgroupingCalculatedResult>}
     * @memberof PurchaseGroupingCalculatedResult
     */
    mergedSubgroupingsCalculated?: Array<MergedSubgroupingCalculatedResult>;
}
/**
 * 
 * @export
 * @interface ReductionByCategory
 */
export interface ReductionByCategory {
    /**
     * 
     * @type {number}
     * @memberof ReductionByCategory
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReductionByCategory
     */
    thirdPartyVatNo?: string;
    /**
     * 
     * @type {Array<SelectedCategory>}
     * @memberof ReductionByCategory
     */
    selectedCategories?: Array<SelectedCategory>;
    /**
     * 
     * @type {Array<SelectedCategory>}
     * @memberof ReductionByCategory
     */
    possibleCategories?: Array<SelectedCategory>;
}
/**
 * 
 * @export
 * @interface ReductionInfo
 */
export interface ReductionInfo {
    /**
     * 
     * @type {number}
     * @memberof ReductionInfo
     */
    id?: number;
    /**
     * VAT (CVR) number
     * @type {string}
     * @memberof ReductionInfo
     */
    thirdpartyVatNo?: string;
    /**
     * forecast id
     * @type {number}
     * @memberof ReductionInfo
     */
    forecastId?: number;
    /**
     * calculation id
     * @type {number}
     * @memberof ReductionInfo
     */
    calculationId?: number;
    /**
     * input
     * @type {number}
     * @memberof ReductionInfo
     */
    year?: number;
    /**
     * input
     * @type {string}
     * @memberof ReductionInfo
     */
    method?: ReductionInfoMethodEnum;
    /**
     * used for both input and output
     * @type {number}
     * @memberof ReductionInfo
     */
    targetPctInput?: number;
    /**
     * used for both input and output
     * @type {number}
     * @memberof ReductionInfo
     */
    targetInput?: number;
    /**
     * used for both input and output
     * @type {number}
     * @memberof ReductionInfo
     */
    targetPctOutput?: number;
    /**
     * used for both input and output
     * @type {number}
     * @memberof ReductionInfo
     */
    targetOutput?: number;
    /**
     * used for output
     * @type {number}
     * @memberof ReductionInfo
     */
    reductionStandard?: number;
    /**
     * used for output
     * @type {number}
     * @memberof ReductionInfo
     */
    reductionOwn?: number;
    /**
     * 
     * @type {string}
     * @memberof ReductionInfo
     */
    scopeType?: ReductionInfoScopeTypeEnum;
    /**
     * the name of the forecast
     * @type {string}
     * @memberof ReductionInfo
     */
    forecastName?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ReductionInfoMethodEnum {
    Manual = 'manual',
    Sbti = 'sbti'
}
/**
    * @export
    * @enum {string}
    */
export enum ReductionInfoScopeTypeEnum {
    Scope12 = 'scope12',
    Scope3 = 'scope3',
    Netzero = 'netzero'
}

/**
 * 
 * @export
 * @interface ReductionResult
 */
export interface ReductionResult {
    /**
     * 
     * @type {Array<GroupingCalculatedResults>}
     * @memberof ReductionResult
     */
    calculations?: Array<GroupingCalculatedResults>;
    /**
     * 
     * @type {ReductionInfo}
     * @memberof ReductionResult
     */
    reductionInfo?: ReductionInfo;
    /**
     * 
     * @type {GroupingCalculatedResults}
     * @memberof ReductionResult
     */
    targetCalculation?: GroupingCalculatedResults;
}
/**
 * 
 * @export
 * @interface ReductionResultByCategory
 */
export interface ReductionResultByCategory {
    /**
     * 
     * @type {ReductionInfo}
     * @memberof ReductionResultByCategory
     */
    reductionInfo?: ReductionInfo;
    /**
     * 
     * @type {CategoryResultsScope3}
     * @memberof ReductionResultByCategory
     */
    basisCalculation?: CategoryResultsScope3;
    /**
     * 
     * @type {CategoryResultsScope3}
     * @memberof ReductionResultByCategory
     */
    targetCalculation?: CategoryResultsScope3;
}
/**
 * 
 * @export
 * @interface ReductionResults
 */
export interface ReductionResults {
    /**
     * valid target years
     * @type {Array<number>}
     * @memberof ReductionResults
     */
    targetYearsScope12?: Array<number>;
    /**
     * valid target years
     * @type {Array<number>}
     * @memberof ReductionResults
     */
    targetYearsScope3?: Array<number>;
    /**
     * valid target years
     * @type {Array<number>}
     * @memberof ReductionResults
     */
    targetYearsNetzero?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ReductionResults
     */
    scope1LastYear?: number;
    /**
     * 
     * @type {number}
     * @memberof ReductionResults
     */
    scope2LastYear?: number;
    /**
     * 
     * @type {number}
     * @memberof ReductionResults
     */
    scope3LastYear?: number;
    /**
     * 
     * @type {Array<ReductionResult>}
     * @memberof ReductionResults
     */
    reductions?: Array<ReductionResult>;
}
/**
 * 
 * @export
 * @interface RegexPattern
 */
export interface RegexPattern {
    /**
     * a textual key for the regex pattern
     * @type {string}
     * @memberof RegexPattern
     */
    regexKey?: string;
    /**
     * Locale for the regex pattern
     * @type {string}
     * @memberof RegexPattern
     */
    locale?: string;
    /**
     * the actual regex pattern
     * @type {string}
     * @memberof RegexPattern
     */
    regexPattern?: string;
}
/**
 * 
 * @export
 * @interface RegexPatterns
 */
export interface RegexPatterns {
    /**
     * 
     * @type {Array<RegexPattern>}
     * @memberof RegexPatterns
     */
    regexPatterns?: Array<RegexPattern>;
}
/**
 * 
 * @export
 * @interface RequestIndividualInfo
 */
export interface RequestIndividualInfo {
    /**
     * id of the object
     * @type {number}
     * @memberof RequestIndividualInfo
     */
    id?: number;
    /**
     * mit id ident of individual at vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof RequestIndividualInfo
     */
    rid?: string;
    /**
     * name of individual at vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof RequestIndividualInfo
     */
    name?: string;
    /**
     * email of individual at vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof RequestIndividualInfo
     */
    email?: string;
    /**
     * cpr of individual at vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof RequestIndividualInfo
     */
    cpr?: string;
    /**
     * individuals vat_nr that has been giving 3. part access
     * @type {string}
     * @memberof RequestIndividualInfo
     */
    cvr?: string;
    /**
     * access id of 3. part access
     * @type {number}
     * @memberof RequestIndividualInfo
     */
    accessId?: number;
}
/**
 * 
 * @export
 * @interface SelectedCategory
 */
export interface SelectedCategory {
    /**
     * 
     * @type {string}
     * @memberof SelectedCategory
     */
    code?: SelectedCategoryCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SelectedCategoryCodeEnum {
    _1 = 'CATEGORY_1',
    _2 = 'CATEGORY_2',
    _3 = 'CATEGORY_3',
    _4 = 'CATEGORY_4',
    _5 = 'CATEGORY_5',
    _6 = 'CATEGORY_6',
    _7 = 'CATEGORY_7',
    _8 = 'CATEGORY_8',
    _9 = 'CATEGORY_9',
    _10 = 'CATEGORY_10',
    _11 = 'CATEGORY_11',
    _12 = 'CATEGORY_12',
    _13 = 'CATEGORY_13',
    _14 = 'CATEGORY_14',
    _15 = 'CATEGORY_15'
}

/**
 * 
 * @export
 * @interface Statistic
 */
export interface Statistic {
    /**
     * 
     * @type {string}
     * @memberof Statistic
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Statistic
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Statistic
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface SubgroupingCalculatedResult
 */
export interface SubgroupingCalculatedResult {
    /**
     * id of the subgrouping
     * @type {number}
     * @memberof SubgroupingCalculatedResult
     */
    subgroupingId?: number;
    /**
     * Subgrouping name
     * @type {string}
     * @memberof SubgroupingCalculatedResult
     */
    subgroupingName?: string;
    /**
     * 
     * @type {CalculatedResult}
     * @memberof SubgroupingCalculatedResult
     */
    calculatedResult?: CalculatedResult;
}
/**
 * 
 * @export
 * @interface TableRow
 */
export interface TableRow {
    /**
     * 
     * @type {string}
     * @memberof TableRow
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface TestContextCreateForecastRequest
 */
export interface TestContextCreateForecastRequest {
    /**
     * 
     * @type {string}
     * @memberof TestContextCreateForecastRequest
     */
    cvr?: string;
    /**
     * 
     * @type {string}
     * @memberof TestContextCreateForecastRequest
     */
    calculationName?: string;
    /**
     * 
     * @type {string}
     * @memberof TestContextCreateForecastRequest
     */
    forecastName?: string;
    /**
     * type of growth (linear, expontential).
     * @type {string}
     * @memberof TestContextCreateForecastRequest
     */
    forecastGrowthType?: TestContextCreateForecastRequestForecastGrowthTypeEnum;
    /**
     * expected growth each year
     * @type {number}
     * @memberof TestContextCreateForecastRequest
     */
    forecastGrowthRate?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum TestContextCreateForecastRequestForecastGrowthTypeEnum {
    Linear = 'linear',
    Exponential = 'exponential'
}

/**
 * 
 * @export
 * @interface TestContextRequest
 */
export interface TestContextRequest {
    /**
     * 
     * @type {string}
     * @memberof TestContextRequest
     */
    calculationName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TestContextRequest
     */
    calculationFinished?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TestContextRequest
     */
    calculationEnvDeclaration?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TestContextRequest
     */
    calculationStartYear?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TestContextRequest
     */
    useKeycloak?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TestContextRequest
     */
    cypressTestTemplateId?: number;
    /**
     * 
     * @type {string}
     * @memberof TestContextRequest
     */
    ridOverride?: string;
    /**
     * 
     * @type {string}
     * @memberof TestContextRequest
     */
    cvrOverride?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TestContextRequest
     */
    useNewestVersion?: boolean;
}
/**
 * 
 * @export
 * @interface TotalsInfo
 */
export interface TotalsInfo {
    /**
     * eg. ALL, SG1, SG52
     * @type {string}
     * @memberof TotalsInfo
     */
    key?: string;
    /**
     * total scope1 value of all lines in calculation
     * @type {number}
     * @memberof TotalsInfo
     */
    scope1?: number;
    /**
     * total scope2 value of all lines in calculation
     * @type {number}
     * @memberof TotalsInfo
     */
    scope2?: number;
    /**
     * total scope3 value of all lines in calculation
     * @type {number}
     * @memberof TotalsInfo
     */
    scope3?: number;
    /**
     * total scope4 value of all lines in calculation
     * @type {number}
     * @memberof TotalsInfo
     */
    outsideScope?: number;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface Version
 */
export interface Version {
    /**
     * Year for emission coeficients
     * @type {number}
     * @memberof Version
     */
    year: number;
    /**
     * version identifier by date
     * @type {number}
     * @memberof Version
     */
    version: number;
    /**
     * emissioncoefieccientVersionId
     * @type {number}
     * @memberof Version
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface Versions
 */
export interface Versions {
    /**
     * 
     * @type {Array<Version>}
     * @memberof Versions
     */
    versions?: Array<Version>;
}

/**
 * AddressesApi - axios parameter creator
 * @export
 */
export const AddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation creates an Address
         * @summary Creates an Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress: async (addressInfo?: AddressInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/addresses`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addressInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addressInfo !== undefined ? addressInfo : {}) : (addressInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation deletes a address
         * @summary Delete address
         * @param {number} addressId address id
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress: async (addressId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            if (addressId === null || addressId === undefined) {
                throw new RequiredError('addressId','Required parameter addressId was null or undefined when calling deleteAddress.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling deleteAddress.');
            }
            const localVarPath = `/v1/addresses/{addressId}/{thirdpartyVatNo}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all addresses given calculationId
         * @summary Returns all addresses given calculationId
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses: async (calculationId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationId' is not null or undefined
            if (calculationId === null || calculationId === undefined) {
                throw new RequiredError('calculationId','Required parameter calculationId was null or undefined when calling getAddresses.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getAddresses.');
            }
            const localVarPath = `/v1/addresses/{calculationId}/{thirdpartyVatNo}`
                .replace(`{${"calculationId"}}`, encodeURIComponent(String(calculationId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation creates an Address
         * @summary update an Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress: async (addressInfo?: AddressInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/addresses`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addressInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addressInfo !== undefined ? addressInfo : {}) : (addressInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation validate an Address
         * @summary validate Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: async (addressInfo?: AddressInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/addresses/validate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addressInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addressInfo !== undefined ? addressInfo : {}) : (addressInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation creates an Address
         * @summary Creates an Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAddress(addressInfo?: AddressInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Address>> {
            const localVarAxiosArgs = await AddressesApiAxiosParamCreator(configuration).createAddress(addressInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation deletes a address
         * @summary Delete address
         * @param {number} addressId address id
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddress(addressId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AddressesApiAxiosParamCreator(configuration).deleteAddress(addressId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all addresses given calculationId
         * @summary Returns all addresses given calculationId
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddresses(calculationId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Addresses>> {
            const localVarAxiosArgs = await AddressesApiAxiosParamCreator(configuration).getAddresses(calculationId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation creates an Address
         * @summary update an Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAddress(addressInfo?: AddressInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Address>> {
            const localVarAxiosArgs = await AddressesApiAxiosParamCreator(configuration).updateAddress(addressInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation validate an Address
         * @summary validate Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAddress(addressInfo?: AddressInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Address>> {
            const localVarAxiosArgs = await AddressesApiAxiosParamCreator(configuration).validateAddress(addressInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation creates an Address
         * @summary Creates an Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress(addressInfo?: AddressInfo, options?: any): AxiosPromise<Address> {
            return AddressesApiFp(configuration).createAddress(addressInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation deletes a address
         * @summary Delete address
         * @param {number} addressId address id
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress(addressId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<void> {
            return AddressesApiFp(configuration).deleteAddress(addressId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all addresses given calculationId
         * @summary Returns all addresses given calculationId
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses(calculationId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<Addresses> {
            return AddressesApiFp(configuration).getAddresses(calculationId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation creates an Address
         * @summary update an Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress(addressInfo?: AddressInfo, options?: any): AxiosPromise<Address> {
            return AddressesApiFp(configuration).updateAddress(addressInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation validate an Address
         * @summary validate Address
         * @param {AddressInfo} [addressInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress(addressInfo?: AddressInfo, options?: any): AxiosPromise<Address> {
            return AddressesApiFp(configuration).validateAddress(addressInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
export class AddressesApi extends BaseAPI {
    /**
     * This operation creates an Address
     * @summary Creates an Address
     * @param {AddressInfo} [addressInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public createAddress(addressInfo?: AddressInfo, options?: any) {
        return AddressesApiFp(this.configuration).createAddress(addressInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation deletes a address
     * @summary Delete address
     * @param {number} addressId address id
     * @param {string} thirdpartyVatNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public deleteAddress(addressId: number, thirdpartyVatNo: string, options?: any) {
        return AddressesApiFp(this.configuration).deleteAddress(addressId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all addresses given calculationId
     * @summary Returns all addresses given calculationId
     * @param {number} calculationId calculation id
     * @param {string} thirdpartyVatNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public getAddresses(calculationId: number, thirdpartyVatNo: string, options?: any) {
        return AddressesApiFp(this.configuration).getAddresses(calculationId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation creates an Address
     * @summary update an Address
     * @param {AddressInfo} [addressInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public updateAddress(addressInfo?: AddressInfo, options?: any) {
        return AddressesApiFp(this.configuration).updateAddress(addressInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation validate an Address
     * @summary validate Address
     * @param {AddressInfo} [addressInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public validateAddress(addressInfo?: AddressInfo, options?: any) {
        return AddressesApiFp(this.configuration).validateAddress(addressInfo, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AiApi - axios parameter creator
 * @export
 */
export const AiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * null
         * @summary Get Ai anwser on question
         * @param {string} question question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiAnswer: async (question: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'question' is not null or undefined
            if (question === null || question === undefined) {
                throw new RequiredError('question','Required parameter question was null or undefined when calling getAiAnswer.');
            }
            const localVarPath = `/v1/ai/chat/{question}`
                .replace(`{${"question"}}`, encodeURIComponent(String(question)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiApi - functional programming interface
 * @export
 */
export const AiApiFp = function(configuration?: Configuration) {
    return {
        /**
         * null
         * @summary Get Ai anwser on question
         * @param {string} question question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAiAnswer(question: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await AiApiAxiosParamCreator(configuration).getAiAnswer(question, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AiApi - factory interface
 * @export
 */
export const AiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * null
         * @summary Get Ai anwser on question
         * @param {string} question question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiAnswer(question: string, options?: any): AxiosPromise<string> {
            return AiApiFp(configuration).getAiAnswer(question, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiApi - object-oriented interface
 * @export
 * @class AiApi
 * @extends {BaseAPI}
 */
export class AiApi extends BaseAPI {
    /**
     * null
     * @summary Get Ai anwser on question
     * @param {string} question question
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public getAiAnswer(question: string, options?: any) {
        return AiApiFp(this.configuration).getAiAnswer(question, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CalculateApi - axios parameter creator
 * @export
 */
export const CalculateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calculates a calculation line
         * @summary Calculates a calculation line
         * @param {Calculate} [calculate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate: async (calculate?: Calculate, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/calculates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calculate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calculate !== undefined ? calculate : {}) : (calculate || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or updates a calculation line
         * @summary Creates or updates a calculation line
         * @param {string} [calculation] JSON string representation of Calculate object
         * @param {any} [file1] 
         * @param {any} [file2] 
         * @param {any} [file3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAndSave: async (calculation?: string, file1?: any, file2?: any, file3?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/calculates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (calculation !== undefined) { 
                localVarFormParams.append('calculation', calculation as any);
            }
    
            if (file1 !== undefined) { 
                localVarFormParams.append('file1', file1 as any);
            }
    
            if (file2 !== undefined) { 
                localVarFormParams.append('file2', file2 as any);
            }
    
            if (file3 !== undefined) { 
                localVarFormParams.append('file3', file3 as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation recalcutates Electricity
         * @summary Gets a list of updated calculations
         * @param {number} calulationId calculation id
         * @param {boolean} state If electricity declaration is environment or plain.
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declarationCalculations: async (calulationId: number, state: boolean, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calulationId' is not null or undefined
            if (calulationId === null || calulationId === undefined) {
                throw new RequiredError('calulationId','Required parameter calulationId was null or undefined when calling declarationCalculations.');
            }
            // verify required parameter 'state' is not null or undefined
            if (state === null || state === undefined) {
                throw new RequiredError('state','Required parameter state was null or undefined when calling declarationCalculations.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling declarationCalculations.');
            }
            const localVarPath = `/v1/calculates/{calulationId}/declaration/{state}/{thirdpartyVatNo}`
                .replace(`{${"calulationId"}}`, encodeURIComponent(String(calulationId)))
                .replace(`{${"state"}}`, encodeURIComponent(String(state)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a calculation line
         * @summary Deletes a calculation line
         * @param {number} id 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalculationLine: async (id: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCalculationLine.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling deleteCalculationLine.');
            }
            const localVarPath = `/v1/calculates/{id}/{thirdpartyVatNo}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets calculation lines for the given subgroupingId
         * @summary Gets calculation lines for the given subgroupingId
         * @param {number} calculationId 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCalculationLines: async (calculationId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationId' is not null or undefined
            if (calculationId === null || calculationId === undefined) {
                throw new RequiredError('calculationId','Required parameter calculationId was null or undefined when calling getAllCalculationLines.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getAllCalculationLines.');
            }
            const localVarPath = `/v1/calculates/{calculationId}/{thirdpartyVatNo}`
                .replace(`{${"calculationId"}}`, encodeURIComponent(String(calculationId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the fields which is needed for the given subgroupingId
         * @summary Gets the fields which is needed for the given subgroupingId
         * @param {number} subgroupingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationFields: async (subgroupingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'subgroupingId' is not null or undefined
            if (subgroupingId === null || subgroupingId === undefined) {
                throw new RequiredError('subgroupingId','Required parameter subgroupingId was null or undefined when calling getCalculationFields.');
            }
            const localVarPath = `/v1/calculates/fields/{subgroupingId}`
                .replace(`{${"subgroupingId"}}`, encodeURIComponent(String(subgroupingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets calculation lines for the given subgroupingId
         * @summary Gets calculation lines for the given subgroupingId
         * @param {number} calculationId 
         * @param {number} subgroupingId 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationLines: async (calculationId: number, subgroupingId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationId' is not null or undefined
            if (calculationId === null || calculationId === undefined) {
                throw new RequiredError('calculationId','Required parameter calculationId was null or undefined when calling getCalculationLines.');
            }
            // verify required parameter 'subgroupingId' is not null or undefined
            if (subgroupingId === null || subgroupingId === undefined) {
                throw new RequiredError('subgroupingId','Required parameter subgroupingId was null or undefined when calling getCalculationLines.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getCalculationLines.');
            }
            const localVarPath = `/v1/calculates/{calculationId}/{subgroupingId}/{thirdpartyVatNo}`
                .replace(`{${"calculationId"}}`, encodeURIComponent(String(calculationId)))
                .replace(`{${"subgroupingId"}}`, encodeURIComponent(String(subgroupingId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation reculculates calculation parts for tranport
         * @summary Gets a list of updated transport calculation parts
         * @param {number} calulationId calculation id
         * @param {boolean} state If RFI is included or not
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfiCalculations: async (calulationId: number, state: boolean, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calulationId' is not null or undefined
            if (calulationId === null || calulationId === undefined) {
                throw new RequiredError('calulationId','Required parameter calulationId was null or undefined when calling rfiCalculations.');
            }
            // verify required parameter 'state' is not null or undefined
            if (state === null || state === undefined) {
                throw new RequiredError('state','Required parameter state was null or undefined when calling rfiCalculations.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling rfiCalculations.');
            }
            const localVarPath = `/v1/calculates/{calulationId}/rfi/{state}/{thirdpartyVatNo}`
                .replace(`{${"calulationId"}}`, encodeURIComponent(String(calulationId)))
                .replace(`{${"state"}}`, encodeURIComponent(String(state)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculateApi - functional programming interface
 * @export
 */
export const CalculateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Calculates a calculation line
         * @summary Calculates a calculation line
         * @param {Calculate} [calculate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculate(calculate?: Calculate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculate>> {
            const localVarAxiosArgs = await CalculateApiAxiosParamCreator(configuration).calculate(calculate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Creates or updates a calculation line
         * @summary Creates or updates a calculation line
         * @param {string} [calculation] JSON string representation of Calculate object
         * @param {any} [file1] 
         * @param {any} [file2] 
         * @param {any} [file3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateAndSave(calculation?: string, file1?: any, file2?: any, file3?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculate>> {
            const localVarAxiosArgs = await CalculateApiAxiosParamCreator(configuration).calculateAndSave(calculation, file1, file2, file3, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation recalcutates Electricity
         * @summary Gets a list of updated calculations
         * @param {number} calulationId calculation id
         * @param {boolean} state If electricity declaration is environment or plain.
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declarationCalculations(calulationId: number, state: boolean, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Calculate>>> {
            const localVarAxiosArgs = await CalculateApiAxiosParamCreator(configuration).declarationCalculations(calulationId, state, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes a calculation line
         * @summary Deletes a calculation line
         * @param {number} id 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalculationLine(id: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await CalculateApiAxiosParamCreator(configuration).deleteCalculationLine(id, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets calculation lines for the given subgroupingId
         * @summary Gets calculation lines for the given subgroupingId
         * @param {number} calculationId 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCalculationLines(calculationId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Calculate>>> {
            const localVarAxiosArgs = await CalculateApiAxiosParamCreator(configuration).getAllCalculationLines(calculationId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets the fields which is needed for the given subgroupingId
         * @summary Gets the fields which is needed for the given subgroupingId
         * @param {number} subgroupingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculationFields(subgroupingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Field>>> {
            const localVarAxiosArgs = await CalculateApiAxiosParamCreator(configuration).getCalculationFields(subgroupingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets calculation lines for the given subgroupingId
         * @summary Gets calculation lines for the given subgroupingId
         * @param {number} calculationId 
         * @param {number} subgroupingId 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculationLines(calculationId: number, subgroupingId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Calculate>>> {
            const localVarAxiosArgs = await CalculateApiAxiosParamCreator(configuration).getCalculationLines(calculationId, subgroupingId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation reculculates calculation parts for tranport
         * @summary Gets a list of updated transport calculation parts
         * @param {number} calulationId calculation id
         * @param {boolean} state If RFI is included or not
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rfiCalculations(calulationId: number, state: boolean, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Calculate>>> {
            const localVarAxiosArgs = await CalculateApiAxiosParamCreator(configuration).rfiCalculations(calulationId, state, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalculateApi - factory interface
 * @export
 */
export const CalculateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Calculates a calculation line
         * @summary Calculates a calculation line
         * @param {Calculate} [calculate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate(calculate?: Calculate, options?: any): AxiosPromise<Calculate> {
            return CalculateApiFp(configuration).calculate(calculate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or updates a calculation line
         * @summary Creates or updates a calculation line
         * @param {string} [calculation] JSON string representation of Calculate object
         * @param {any} [file1] 
         * @param {any} [file2] 
         * @param {any} [file3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAndSave(calculation?: string, file1?: any, file2?: any, file3?: any, options?: any): AxiosPromise<Calculate> {
            return CalculateApiFp(configuration).calculateAndSave(calculation, file1, file2, file3, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation recalcutates Electricity
         * @summary Gets a list of updated calculations
         * @param {number} calulationId calculation id
         * @param {boolean} state If electricity declaration is environment or plain.
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declarationCalculations(calulationId: number, state: boolean, thirdpartyVatNo: string, options?: any): AxiosPromise<Array<Calculate>> {
            return CalculateApiFp(configuration).declarationCalculations(calulationId, state, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a calculation line
         * @summary Deletes a calculation line
         * @param {number} id 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalculationLine(id: number, thirdpartyVatNo: string, options?: any): AxiosPromise<string> {
            return CalculateApiFp(configuration).deleteCalculationLine(id, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets calculation lines for the given subgroupingId
         * @summary Gets calculation lines for the given subgroupingId
         * @param {number} calculationId 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCalculationLines(calculationId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<Array<Calculate>> {
            return CalculateApiFp(configuration).getAllCalculationLines(calculationId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the fields which is needed for the given subgroupingId
         * @summary Gets the fields which is needed for the given subgroupingId
         * @param {number} subgroupingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationFields(subgroupingId: number, options?: any): AxiosPromise<Array<Field>> {
            return CalculateApiFp(configuration).getCalculationFields(subgroupingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets calculation lines for the given subgroupingId
         * @summary Gets calculation lines for the given subgroupingId
         * @param {number} calculationId 
         * @param {number} subgroupingId 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationLines(calculationId: number, subgroupingId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<Array<Calculate>> {
            return CalculateApiFp(configuration).getCalculationLines(calculationId, subgroupingId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation reculculates calculation parts for tranport
         * @summary Gets a list of updated transport calculation parts
         * @param {number} calulationId calculation id
         * @param {boolean} state If RFI is included or not
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfiCalculations(calulationId: number, state: boolean, thirdpartyVatNo: string, options?: any): AxiosPromise<Array<Calculate>> {
            return CalculateApiFp(configuration).rfiCalculations(calulationId, state, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculateApi - object-oriented interface
 * @export
 * @class CalculateApi
 * @extends {BaseAPI}
 */
export class CalculateApi extends BaseAPI {
    /**
     * Calculates a calculation line
     * @summary Calculates a calculation line
     * @param {Calculate} [calculate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculateApi
     */
    public calculate(calculate?: Calculate, options?: any) {
        return CalculateApiFp(this.configuration).calculate(calculate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or updates a calculation line
     * @summary Creates or updates a calculation line
     * @param {string} [calculation] JSON string representation of Calculate object
     * @param {any} [file1] 
     * @param {any} [file2] 
     * @param {any} [file3] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculateApi
     */
    public calculateAndSave(calculation?: string, file1?: any, file2?: any, file3?: any, options?: any) {
        return CalculateApiFp(this.configuration).calculateAndSave(calculation, file1, file2, file3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation recalcutates Electricity
     * @summary Gets a list of updated calculations
     * @param {number} calulationId calculation id
     * @param {boolean} state If electricity declaration is environment or plain.
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculateApi
     */
    public declarationCalculations(calulationId: number, state: boolean, thirdpartyVatNo: string, options?: any) {
        return CalculateApiFp(this.configuration).declarationCalculations(calulationId, state, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a calculation line
     * @summary Deletes a calculation line
     * @param {number} id 
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculateApi
     */
    public deleteCalculationLine(id: number, thirdpartyVatNo: string, options?: any) {
        return CalculateApiFp(this.configuration).deleteCalculationLine(id, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets calculation lines for the given subgroupingId
     * @summary Gets calculation lines for the given subgroupingId
     * @param {number} calculationId 
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculateApi
     */
    public getAllCalculationLines(calculationId: number, thirdpartyVatNo: string, options?: any) {
        return CalculateApiFp(this.configuration).getAllCalculationLines(calculationId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the fields which is needed for the given subgroupingId
     * @summary Gets the fields which is needed for the given subgroupingId
     * @param {number} subgroupingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculateApi
     */
    public getCalculationFields(subgroupingId: number, options?: any) {
        return CalculateApiFp(this.configuration).getCalculationFields(subgroupingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets calculation lines for the given subgroupingId
     * @summary Gets calculation lines for the given subgroupingId
     * @param {number} calculationId 
     * @param {number} subgroupingId 
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculateApi
     */
    public getCalculationLines(calculationId: number, subgroupingId: number, thirdpartyVatNo: string, options?: any) {
        return CalculateApiFp(this.configuration).getCalculationLines(calculationId, subgroupingId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation reculculates calculation parts for tranport
     * @summary Gets a list of updated transport calculation parts
     * @param {number} calulationId calculation id
     * @param {boolean} state If RFI is included or not
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculateApi
     */
    public rfiCalculations(calulationId: number, state: boolean, thirdpartyVatNo: string, options?: any) {
        return CalculateApiFp(this.configuration).rfiCalculations(calulationId, state, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CalculationApi - axios parameter creator
 * @export
 */
export const CalculationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary Retreives a calculations addresses
         * @param {number} calculationId calculation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationAddresses: async (calculationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationId' is not null or undefined
            if (calculationId === null || calculationId === undefined) {
                throw new RequiredError('calculationId','Required parameter calculationId was null or undefined when calling getCalculationAddresses.');
            }
            const localVarPath = `/v1/calculation/addresses/{calculationId}`
                .replace(`{${"calculationId"}}`, encodeURIComponent(String(calculationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationApi - functional programming interface
 * @export
 */
export const CalculationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary Retreives a calculations addresses
         * @param {number} calculationId calculation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculationAddresses(calculationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Addresses>> {
            const localVarAxiosArgs = await CalculationApiAxiosParamCreator(configuration).getCalculationAddresses(calculationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalculationApi - factory interface
 * @export
 */
export const CalculationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary Retreives a calculations addresses
         * @param {number} calculationId calculation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationAddresses(calculationId: number, options?: any): AxiosPromise<Addresses> {
            return CalculationApiFp(configuration).getCalculationAddresses(calculationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculationApi - object-oriented interface
 * @export
 * @class CalculationApi
 * @extends {BaseAPI}
 */
export class CalculationApi extends BaseAPI {
    /**
     * This operation fetches all addresses related to a calculation by its unique ID
     * @summary Retreives a calculations addresses
     * @param {number} calculationId calculation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationApi
     */
    public getCalculationAddresses(calculationId: number, options?: any) {
        return CalculationApiFp(this.configuration).getCalculationAddresses(calculationId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CalculationImportExportApi - axios parameter creator
 * @export
 */
export const CalculationImportExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * returning a json string
         * @summary Export the chosen calculation as json string
         * @param {number} calculationId version for export
         * @param {string} calculationExportName 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCalculationJson: async (calculationId: number, calculationExportName: string, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationId' is not null or undefined
            if (calculationId === null || calculationId === undefined) {
                throw new RequiredError('calculationId','Required parameter calculationId was null or undefined when calling exportCalculationJson.');
            }
            // verify required parameter 'calculationExportName' is not null or undefined
            if (calculationExportName === null || calculationExportName === undefined) {
                throw new RequiredError('calculationExportName','Required parameter calculationExportName was null or undefined when calling exportCalculationJson.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling exportCalculationJson.');
            }
            const localVarPath = `/v1/calculationimportexport/exportCalculationJson/{calculationId}/{calculationExportName}/{thirdpartyVatNo}`
                .replace(`{${"calculationId"}}`, encodeURIComponent(String(calculationId)))
                .replace(`{${"calculationExportName"}}`, encodeURIComponent(String(calculationExportName)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import Json file with calculation
         * @summary Import Json file with calculation
         * @param {string} calculationImportName 
         * @param {any} [file] 
         * @param {boolean} [ignoreScopeValues] if true ignores scope values and always import if possible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importJson: async (calculationImportName: string, file?: any, ignoreScopeValues?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationImportName' is not null or undefined
            if (calculationImportName === null || calculationImportName === undefined) {
                throw new RequiredError('calculationImportName','Required parameter calculationImportName was null or undefined when calling importJson.');
            }
            const localVarPath = `/v1/calculationimportexport/importCalculationJson/{calculationImportName}`
                .replace(`{${"calculationImportName"}}`, encodeURIComponent(String(calculationImportName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (ignoreScopeValues !== undefined) { 
                localVarFormParams.append('ignoreScopeValues', ignoreScopeValues as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationImportExportApi - functional programming interface
 * @export
 */
export const CalculationImportExportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * returning a json string
         * @summary Export the chosen calculation as json string
         * @param {number} calculationId version for export
         * @param {string} calculationExportName 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCalculationJson(calculationId: number, calculationExportName: string, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await CalculationImportExportApiAxiosParamCreator(configuration).exportCalculationJson(calculationId, calculationExportName, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Import Json file with calculation
         * @summary Import Json file with calculation
         * @param {string} calculationImportName 
         * @param {any} [file] 
         * @param {boolean} [ignoreScopeValues] if true ignores scope values and always import if possible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importJson(calculationImportName: string, file?: any, ignoreScopeValues?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocalizedValidationError>>> {
            const localVarAxiosArgs = await CalculationImportExportApiAxiosParamCreator(configuration).importJson(calculationImportName, file, ignoreScopeValues, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalculationImportExportApi - factory interface
 * @export
 */
export const CalculationImportExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * returning a json string
         * @summary Export the chosen calculation as json string
         * @param {number} calculationId version for export
         * @param {string} calculationExportName 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCalculationJson(calculationId: number, calculationExportName: string, thirdpartyVatNo: string, options?: any): AxiosPromise<string> {
            return CalculationImportExportApiFp(configuration).exportCalculationJson(calculationId, calculationExportName, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Import Json file with calculation
         * @summary Import Json file with calculation
         * @param {string} calculationImportName 
         * @param {any} [file] 
         * @param {boolean} [ignoreScopeValues] if true ignores scope values and always import if possible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importJson(calculationImportName: string, file?: any, ignoreScopeValues?: boolean, options?: any): AxiosPromise<Array<LocalizedValidationError>> {
            return CalculationImportExportApiFp(configuration).importJson(calculationImportName, file, ignoreScopeValues, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculationImportExportApi - object-oriented interface
 * @export
 * @class CalculationImportExportApi
 * @extends {BaseAPI}
 */
export class CalculationImportExportApi extends BaseAPI {
    /**
     * returning a json string
     * @summary Export the chosen calculation as json string
     * @param {number} calculationId version for export
     * @param {string} calculationExportName 
     * @param {string} thirdpartyVatNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationImportExportApi
     */
    public exportCalculationJson(calculationId: number, calculationExportName: string, thirdpartyVatNo: string, options?: any) {
        return CalculationImportExportApiFp(this.configuration).exportCalculationJson(calculationId, calculationExportName, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import Json file with calculation
     * @summary Import Json file with calculation
     * @param {string} calculationImportName 
     * @param {any} [file] 
     * @param {boolean} [ignoreScopeValues] if true ignores scope values and always import if possible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationImportExportApi
     */
    public importJson(calculationImportName: string, file?: any, ignoreScopeValues?: boolean, options?: any) {
        return CalculationImportExportApiFp(this.configuration).importJson(calculationImportName, file, ignoreScopeValues, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CalculationsApi - axios parameter creator
 * @export
 */
export const CalculationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * check emission for country and year
         * @summary check emission for country and year
         * @param {string} countrycode country code
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEmission: async (countrycode: string, year: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'countrycode' is not null or undefined
            if (countrycode === null || countrycode === undefined) {
                throw new RequiredError('countrycode','Required parameter countrycode was null or undefined when calling checkEmission.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling checkEmission.');
            }
            const localVarPath = `/v1/calculations/check-emission/{countrycode}/{year}`
                .replace(`{${"countrycode"}}`, encodeURIComponent(String(countrycode)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation copy a Calculation.
         * @summary Copy a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyCalculation: async (calculation?: Calculation, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/calculations/copy`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calculation !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calculation !== undefined ? calculation : {}) : (calculation || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation creates a Calculation.
         * @summary Creates a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalculation: async (calculation?: Calculation, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/calculations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calculation !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calculation !== undefined ? calculation : {}) : (calculation || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exports the results of this calculation to excel
         * @summary Exports the results of the given calculation to excel
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo if set use this when export
         * @param {string} countrycode country code, default is DK
         * @param {string} environment prod, dev etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportToExcel: async (calculationId: number, thirdpartyVatNo: string, countrycode: string, environment: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationId' is not null or undefined
            if (calculationId === null || calculationId === undefined) {
                throw new RequiredError('calculationId','Required parameter calculationId was null or undefined when calling exportToExcel.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling exportToExcel.');
            }
            // verify required parameter 'countrycode' is not null or undefined
            if (countrycode === null || countrycode === undefined) {
                throw new RequiredError('countrycode','Required parameter countrycode was null or undefined when calling exportToExcel.');
            }
            // verify required parameter 'environment' is not null or undefined
            if (environment === null || environment === undefined) {
                throw new RequiredError('environment','Required parameter environment was null or undefined when calling exportToExcel.');
            }
            const localVarPath = `/v1/calculations/{calculationId}/export/{thirdpartyVatNo}/{countrycode}/{environment}`
                .replace(`{${"calculationId"}}`, encodeURIComponent(String(calculationId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)))
                .replace(`{${"countrycode"}}`, encodeURIComponent(String(countrycode)))
                .replace(`{${"environment"}}`, encodeURIComponent(String(environment)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Gets a total calculations results for baseline user
         * @param {CalculationAndLines} [calculationAndLines] calculation with all lines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseModuleResultCalculations: async (calculationAndLines?: CalculationAndLines, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/calculations/basemodule/totals`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calculationAndLines !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calculationAndLines !== undefined ? calculationAndLines : {}) : (calculationAndLines || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches a Calculation.
         * @summary Gets a calculation
         * @param {number} id calculation id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculation: async (id: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCalculation.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getCalculation.');
            }
            const localVarPath = `/v1/calculations/{id}/{thirdpartyVatNo}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches all Calculations.
         * @summary Gets a list of calculations
         * @param {string} vatNo VAT (CVR) number
         * @param {string} contactPersonRID 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculations: async (vatNo: string, contactPersonRID: string, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling getCalculations.');
            }
            // verify required parameter 'contactPersonRID' is not null or undefined
            if (contactPersonRID === null || contactPersonRID === undefined) {
                throw new RequiredError('contactPersonRID','Required parameter contactPersonRID was null or undefined when calling getCalculations.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getCalculations.');
            }
            const localVarPath = `/v1/calculations/{vatNo}/{contactPersonRID}/{thirdpartyVatNo}`
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)))
                .replace(`{${"contactPersonRID"}}`, encodeURIComponent(String(contactPersonRID)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches all Calculations.
         * @summary Gets a list of calculations
         * @param {string} vatNo VAT (CVR) number
         * @param {string} searchString calc name or email or company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationsForAdmin: async (vatNo: string, searchString: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling getCalculationsForAdmin.');
            }
            // verify required parameter 'searchString' is not null or undefined
            if (searchString === null || searchString === undefined) {
                throw new RequiredError('searchString','Required parameter searchString was null or undefined when calling getCalculationsForAdmin.');
            }
            const localVarPath = `/v1/calculations/admin/{vatNo}/{searchString}`
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)))
                .replace(`{${"searchString"}}`, encodeURIComponent(String(searchString)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Gets a total calculations results for a given id
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultCalculations: async (calculationId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationId' is not null or undefined
            if (calculationId === null || calculationId === undefined) {
                throw new RequiredError('calculationId','Required parameter calculationId was null or undefined when calling getResultCalculations.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getResultCalculations.');
            }
            const localVarPath = `/v1/calculations/totals/{calculationId}/{thirdpartyVatNo}`
                .replace(`{${"calculationId"}}`, encodeURIComponent(String(calculationId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary recalculate all calulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/calculations/recalculateAll`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary recalculate own calulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateOwn: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/calculations/recalculateOwn`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation updates a Calculation
         * @summary updates a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalculation: async (calculation?: Calculation, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/calculations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calculation !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calculation !== undefined ? calculation : {}) : (calculation || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update cvr on calculation
         * @summary Update cvr on calculation
         * @param {number} calulationId calculation id
         * @param {string} vatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalculationWithCVR: async (calulationId: number, vatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calulationId' is not null or undefined
            if (calulationId === null || calulationId === undefined) {
                throw new RequiredError('calulationId','Required parameter calulationId was null or undefined when calling updateCalculationWithCVR.');
            }
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling updateCalculationWithCVR.');
            }
            const localVarPath = `/v1/calculations/change/{calulationId}/{vatNo}`
                .replace(`{${"calulationId"}}`, encodeURIComponent(String(calulationId)))
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update emission version on calculation
         * @summary Update emission version on calculation
         * @param {number} calulationId calculation id
         * @param {number} year 
         * @param {number} version 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalculationWithEmissionCoefficientVersion: async (calulationId: number, year: number, version: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calulationId' is not null or undefined
            if (calulationId === null || calulationId === undefined) {
                throw new RequiredError('calulationId','Required parameter calulationId was null or undefined when calling updateCalculationWithEmissionCoefficientVersion.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling updateCalculationWithEmissionCoefficientVersion.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateCalculationWithEmissionCoefficientVersion.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling updateCalculationWithEmissionCoefficientVersion.');
            }
            const localVarPath = `/v1/calculations/version/{calulationId}/{year}/{version}/{thirdpartyVatNo}`
                .replace(`{${"calulationId"}}`, encodeURIComponent(String(calulationId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationsApi - functional programming interface
 * @export
 */
export const CalculationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * check emission for country and year
         * @summary check emission for country and year
         * @param {string} countrycode country code
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkEmission(countrycode: string, year: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmissionCoefficientsInfo>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).checkEmission(countrycode, year, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation copy a Calculation.
         * @summary Copy a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyCalculation(calculation?: Calculation, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculation>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).copyCalculation(calculation, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation creates a Calculation.
         * @summary Creates a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalculation(calculation?: Calculation, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculation>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).createCalculation(calculation, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Exports the results of this calculation to excel
         * @summary Exports the results of the given calculation to excel
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo if set use this when export
         * @param {string} countrycode country code, default is DK
         * @param {string} environment prod, dev etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportToExcel(calculationId: number, thirdpartyVatNo: string, countrycode: string, environment: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).exportToExcel(calculationId, thirdpartyVatNo, countrycode, environment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Gets a total calculations results for baseline user
         * @param {CalculationAndLines} [calculationAndLines] calculation with all lines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBaseModuleResultCalculations(calculationAndLines?: CalculationAndLines, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupingCalculatedResults>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).getBaseModuleResultCalculations(calculationAndLines, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches a Calculation.
         * @summary Gets a calculation
         * @param {number} id calculation id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculation(id: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculation>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).getCalculation(id, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches all Calculations.
         * @summary Gets a list of calculations
         * @param {string} vatNo VAT (CVR) number
         * @param {string} contactPersonRID 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculations(vatNo: string, contactPersonRID: string, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculations>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).getCalculations(vatNo, contactPersonRID, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches all Calculations.
         * @summary Gets a list of calculations
         * @param {string} vatNo VAT (CVR) number
         * @param {string} searchString calc name or email or company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculationsForAdmin(vatNo: string, searchString: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculations>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).getCalculationsForAdmin(vatNo, searchString, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Gets a total calculations results for a given id
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResultCalculations(calculationId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupingCalculatedResults>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).getResultCalculations(calculationId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary recalculate all calulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculateAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).recalculateAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary recalculate own calulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculateOwn(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).recalculateOwn(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation updates a Calculation
         * @summary updates a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalculation(calculation?: Calculation, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculation>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).updateCalculation(calculation, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update cvr on calculation
         * @summary Update cvr on calculation
         * @param {number} calulationId calculation id
         * @param {string} vatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalculationWithCVR(calulationId: number, vatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculation>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).updateCalculationWithCVR(calulationId, vatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update emission version on calculation
         * @summary Update emission version on calculation
         * @param {number} calulationId calculation id
         * @param {number} year 
         * @param {number} version 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalculationWithEmissionCoefficientVersion(calulationId: number, year: number, version: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Calculation>> {
            const localVarAxiosArgs = await CalculationsApiAxiosParamCreator(configuration).updateCalculationWithEmissionCoefficientVersion(calulationId, year, version, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalculationsApi - factory interface
 * @export
 */
export const CalculationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * check emission for country and year
         * @summary check emission for country and year
         * @param {string} countrycode country code
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEmission(countrycode: string, year: number, options?: any): AxiosPromise<EmissionCoefficientsInfo> {
            return CalculationsApiFp(configuration).checkEmission(countrycode, year, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation copy a Calculation.
         * @summary Copy a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyCalculation(calculation?: Calculation, options?: any): AxiosPromise<Calculation> {
            return CalculationsApiFp(configuration).copyCalculation(calculation, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation creates a Calculation.
         * @summary Creates a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalculation(calculation?: Calculation, options?: any): AxiosPromise<Calculation> {
            return CalculationsApiFp(configuration).createCalculation(calculation, options).then((request) => request(axios, basePath));
        },
        /**
         * Exports the results of this calculation to excel
         * @summary Exports the results of the given calculation to excel
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo if set use this when export
         * @param {string} countrycode country code, default is DK
         * @param {string} environment prod, dev etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportToExcel(calculationId: number, thirdpartyVatNo: string, countrycode: string, environment: string, options?: any): AxiosPromise<any> {
            return CalculationsApiFp(configuration).exportToExcel(calculationId, thirdpartyVatNo, countrycode, environment, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Gets a total calculations results for baseline user
         * @param {CalculationAndLines} [calculationAndLines] calculation with all lines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseModuleResultCalculations(calculationAndLines?: CalculationAndLines, options?: any): AxiosPromise<GroupingCalculatedResults> {
            return CalculationsApiFp(configuration).getBaseModuleResultCalculations(calculationAndLines, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches a Calculation.
         * @summary Gets a calculation
         * @param {number} id calculation id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculation(id: number, thirdpartyVatNo: string, options?: any): AxiosPromise<Calculation> {
            return CalculationsApiFp(configuration).getCalculation(id, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches all Calculations.
         * @summary Gets a list of calculations
         * @param {string} vatNo VAT (CVR) number
         * @param {string} contactPersonRID 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculations(vatNo: string, contactPersonRID: string, thirdpartyVatNo: string, options?: any): AxiosPromise<Calculations> {
            return CalculationsApiFp(configuration).getCalculations(vatNo, contactPersonRID, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches all Calculations.
         * @summary Gets a list of calculations
         * @param {string} vatNo VAT (CVR) number
         * @param {string} searchString calc name or email or company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationsForAdmin(vatNo: string, searchString: string, options?: any): AxiosPromise<Calculations> {
            return CalculationsApiFp(configuration).getCalculationsForAdmin(vatNo, searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Gets a total calculations results for a given id
         * @param {number} calculationId calculation id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultCalculations(calculationId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<GroupingCalculatedResults> {
            return CalculationsApiFp(configuration).getResultCalculations(calculationId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary recalculate all calulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateAll(options?: any): AxiosPromise<string> {
            return CalculationsApiFp(configuration).recalculateAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary recalculate own calulations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateOwn(options?: any): AxiosPromise<string> {
            return CalculationsApiFp(configuration).recalculateOwn(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation updates a Calculation
         * @summary updates a Calculation
         * @param {Calculation} [calculation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalculation(calculation?: Calculation, options?: any): AxiosPromise<Calculation> {
            return CalculationsApiFp(configuration).updateCalculation(calculation, options).then((request) => request(axios, basePath));
        },
        /**
         * Update cvr on calculation
         * @summary Update cvr on calculation
         * @param {number} calulationId calculation id
         * @param {string} vatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalculationWithCVR(calulationId: number, vatNo: string, options?: any): AxiosPromise<Calculation> {
            return CalculationsApiFp(configuration).updateCalculationWithCVR(calulationId, vatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Update emission version on calculation
         * @summary Update emission version on calculation
         * @param {number} calulationId calculation id
         * @param {number} year 
         * @param {number} version 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalculationWithEmissionCoefficientVersion(calulationId: number, year: number, version: number, thirdpartyVatNo: string, options?: any): AxiosPromise<Calculation> {
            return CalculationsApiFp(configuration).updateCalculationWithEmissionCoefficientVersion(calulationId, year, version, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculationsApi - object-oriented interface
 * @export
 * @class CalculationsApi
 * @extends {BaseAPI}
 */
export class CalculationsApi extends BaseAPI {
    /**
     * check emission for country and year
     * @summary check emission for country and year
     * @param {string} countrycode country code
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public checkEmission(countrycode: string, year: number, options?: any) {
        return CalculationsApiFp(this.configuration).checkEmission(countrycode, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation copy a Calculation.
     * @summary Copy a Calculation
     * @param {Calculation} [calculation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public copyCalculation(calculation?: Calculation, options?: any) {
        return CalculationsApiFp(this.configuration).copyCalculation(calculation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation creates a Calculation.
     * @summary Creates a Calculation
     * @param {Calculation} [calculation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public createCalculation(calculation?: Calculation, options?: any) {
        return CalculationsApiFp(this.configuration).createCalculation(calculation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exports the results of this calculation to excel
     * @summary Exports the results of the given calculation to excel
     * @param {number} calculationId calculation id
     * @param {string} thirdpartyVatNo if set use this when export
     * @param {string} countrycode country code, default is DK
     * @param {string} environment prod, dev etc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public exportToExcel(calculationId: number, thirdpartyVatNo: string, countrycode: string, environment: string, options?: any) {
        return CalculationsApiFp(this.configuration).exportToExcel(calculationId, thirdpartyVatNo, countrycode, environment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches a Calculations grouped by grouping (subject).
     * @summary Gets a total calculations results for baseline user
     * @param {CalculationAndLines} [calculationAndLines] calculation with all lines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public getBaseModuleResultCalculations(calculationAndLines?: CalculationAndLines, options?: any) {
        return CalculationsApiFp(this.configuration).getBaseModuleResultCalculations(calculationAndLines, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches a Calculation.
     * @summary Gets a calculation
     * @param {number} id calculation id
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public getCalculation(id: number, thirdpartyVatNo: string, options?: any) {
        return CalculationsApiFp(this.configuration).getCalculation(id, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches all Calculations.
     * @summary Gets a list of calculations
     * @param {string} vatNo VAT (CVR) number
     * @param {string} contactPersonRID 
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public getCalculations(vatNo: string, contactPersonRID: string, thirdpartyVatNo: string, options?: any) {
        return CalculationsApiFp(this.configuration).getCalculations(vatNo, contactPersonRID, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches all Calculations.
     * @summary Gets a list of calculations
     * @param {string} vatNo VAT (CVR) number
     * @param {string} searchString calc name or email or company name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public getCalculationsForAdmin(vatNo: string, searchString: string, options?: any) {
        return CalculationsApiFp(this.configuration).getCalculationsForAdmin(vatNo, searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches a Calculations grouped by grouping (subject).
     * @summary Gets a total calculations results for a given id
     * @param {number} calculationId calculation id
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public getResultCalculations(calculationId: number, thirdpartyVatNo: string, options?: any) {
        return CalculationsApiFp(this.configuration).getResultCalculations(calculationId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary recalculate all calulations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public recalculateAll(options?: any) {
        return CalculationsApiFp(this.configuration).recalculateAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary recalculate own calulations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public recalculateOwn(options?: any) {
        return CalculationsApiFp(this.configuration).recalculateOwn(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation updates a Calculation
     * @summary updates a Calculation
     * @param {Calculation} [calculation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public updateCalculation(calculation?: Calculation, options?: any) {
        return CalculationsApiFp(this.configuration).updateCalculation(calculation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update cvr on calculation
     * @summary Update cvr on calculation
     * @param {number} calulationId calculation id
     * @param {string} vatNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public updateCalculationWithCVR(calulationId: number, vatNo: string, options?: any) {
        return CalculationsApiFp(this.configuration).updateCalculationWithCVR(calulationId, vatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update emission version on calculation
     * @summary Update emission version on calculation
     * @param {number} calulationId calculation id
     * @param {number} year 
     * @param {number} version 
     * @param {string} thirdpartyVatNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    public updateCalculationWithEmissionCoefficientVersion(calulationId: number, year: number, version: number, thirdpartyVatNo: string, options?: any) {
        return CalculationsApiFp(this.configuration).updateCalculationWithEmissionCoefficientVersion(calulationId, year, version, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CompaniesApi - axios parameter creator
 * @export
 */
export const CompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation returns a company
         * @summary Fetches company based on vatNo
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompany: async (vatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling fetchCompany.');
            }
            const localVarPath = `/v1/companies/{vatNo}`
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation returns a company
         * @summary Fetches company based on vatNo
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchCompany(vatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await CompaniesApiAxiosParamCreator(configuration).fetchCompany(vatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation returns a company
         * @summary Fetches company based on vatNo
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompany(vatNo: string, options?: any): AxiosPromise<Company> {
            return CompaniesApiFp(configuration).fetchCompany(vatNo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
    /**
     * This operation returns a company
     * @summary Fetches company based on vatNo
     * @param {string} vatNo VAT (CVR) number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public fetchCompany(vatNo: string, options?: any) {
        return CompaniesApiFp(this.configuration).fetchCompany(vatNo, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ComparisonsApi - axios parameter creator
 * @export
 */
export const ComparisonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a comparison of calculations
         * @param {CompareMetaObject} [compareMetaObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparison: async (compareMetaObject?: CompareMetaObject, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/comparisons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof compareMetaObject !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(compareMetaObject !== undefined ? compareMetaObject : {}) : (compareMetaObject || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compareMetaObjectId 
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComparison: async (compareMetaObjectId: number, vatNo: string, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'compareMetaObjectId' is not null or undefined
            if (compareMetaObjectId === null || compareMetaObjectId === undefined) {
                throw new RequiredError('compareMetaObjectId','Required parameter compareMetaObjectId was null or undefined when calling deleteComparison.');
            }
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling deleteComparison.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling deleteComparison.');
            }
            const localVarPath = `/v1/comparisons/delete/{compareMetaObjectId}/{vatNo}/{thirdpartyVatNo}`
                .replace(`{${"compareMetaObjectId"}}`, encodeURIComponent(String(compareMetaObjectId)))
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * null
         * @summary List of comparison names to be shown for specific user
         * @param {number} comparisonId 
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparison: async (comparisonId: number, vatNo: string, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'comparisonId' is not null or undefined
            if (comparisonId === null || comparisonId === undefined) {
                throw new RequiredError('comparisonId','Required parameter comparisonId was null or undefined when calling getComparison.');
            }
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling getComparison.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getComparison.');
            }
            const localVarPath = `/v1/comparisons/get/{comparisonId}/{vatNo}/{thirdpartyVatNo}`
                .replace(`{${"comparisonId"}}`, encodeURIComponent(String(comparisonId)))
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * null
         * @summary List of comparison names to be shown for specific user
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparisonList: async (vatNo: string, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling getComparisonList.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getComparisonList.');
            }
            const localVarPath = `/v1/comparisons/getList/{vatNo}/{thirdpartyVatNo}`
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update comparison
         * @param {CompareMetaObject} [compareMetaObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComparison: async (compareMetaObject?: CompareMetaObject, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/comparisons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof compareMetaObject !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(compareMetaObject !== undefined ? compareMetaObject : {}) : (compareMetaObject || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparisonsApi - functional programming interface
 * @export
 */
export const ComparisonsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a comparison of calculations
         * @param {CompareMetaObject} [compareMetaObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComparison(compareMetaObject?: CompareMetaObject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonObject>> {
            const localVarAxiosArgs = await ComparisonsApiAxiosParamCreator(configuration).createComparison(compareMetaObject, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compareMetaObjectId 
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComparison(compareMetaObjectId: number, vatNo: string, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ComparisonsApiAxiosParamCreator(configuration).deleteComparison(compareMetaObjectId, vatNo, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * null
         * @summary List of comparison names to be shown for specific user
         * @param {number} comparisonId 
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComparison(comparisonId: number, vatNo: string, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonObject>> {
            const localVarAxiosArgs = await ComparisonsApiAxiosParamCreator(configuration).getComparison(comparisonId, vatNo, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * null
         * @summary List of comparison names to be shown for specific user
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComparisonList(vatNo: string, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComparisonOverviewInfo>>> {
            const localVarAxiosArgs = await ComparisonsApiAxiosParamCreator(configuration).getComparisonList(vatNo, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary update comparison
         * @param {CompareMetaObject} [compareMetaObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComparison(compareMetaObject?: CompareMetaObject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonObject>> {
            const localVarAxiosArgs = await ComparisonsApiAxiosParamCreator(configuration).updateComparison(compareMetaObject, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ComparisonsApi - factory interface
 * @export
 */
export const ComparisonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary create a comparison of calculations
         * @param {CompareMetaObject} [compareMetaObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparison(compareMetaObject?: CompareMetaObject, options?: any): AxiosPromise<ComparisonObject> {
            return ComparisonsApiFp(configuration).createComparison(compareMetaObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} compareMetaObjectId 
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComparison(compareMetaObjectId: number, vatNo: string, thirdpartyVatNo: string, options?: any): AxiosPromise<string> {
            return ComparisonsApiFp(configuration).deleteComparison(compareMetaObjectId, vatNo, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * null
         * @summary List of comparison names to be shown for specific user
         * @param {number} comparisonId 
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparison(comparisonId: number, vatNo: string, thirdpartyVatNo: string, options?: any): AxiosPromise<ComparisonObject> {
            return ComparisonsApiFp(configuration).getComparison(comparisonId, vatNo, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * null
         * @summary List of comparison names to be shown for specific user
         * @param {string} vatNo 
         * @param {string} thirdpartyVatNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparisonList(vatNo: string, thirdpartyVatNo: string, options?: any): AxiosPromise<Array<ComparisonOverviewInfo>> {
            return ComparisonsApiFp(configuration).getComparisonList(vatNo, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update comparison
         * @param {CompareMetaObject} [compareMetaObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComparison(compareMetaObject?: CompareMetaObject, options?: any): AxiosPromise<ComparisonObject> {
            return ComparisonsApiFp(configuration).updateComparison(compareMetaObject, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComparisonsApi - object-oriented interface
 * @export
 * @class ComparisonsApi
 * @extends {BaseAPI}
 */
export class ComparisonsApi extends BaseAPI {
    /**
     * 
     * @summary create a comparison of calculations
     * @param {CompareMetaObject} [compareMetaObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public createComparison(compareMetaObject?: CompareMetaObject, options?: any) {
        return ComparisonsApiFp(this.configuration).createComparison(compareMetaObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} compareMetaObjectId 
     * @param {string} vatNo 
     * @param {string} thirdpartyVatNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public deleteComparison(compareMetaObjectId: number, vatNo: string, thirdpartyVatNo: string, options?: any) {
        return ComparisonsApiFp(this.configuration).deleteComparison(compareMetaObjectId, vatNo, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * null
     * @summary List of comparison names to be shown for specific user
     * @param {number} comparisonId 
     * @param {string} vatNo 
     * @param {string} thirdpartyVatNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public getComparison(comparisonId: number, vatNo: string, thirdpartyVatNo: string, options?: any) {
        return ComparisonsApiFp(this.configuration).getComparison(comparisonId, vatNo, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * null
     * @summary List of comparison names to be shown for specific user
     * @param {string} vatNo 
     * @param {string} thirdpartyVatNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public getComparisonList(vatNo: string, thirdpartyVatNo: string, options?: any) {
        return ComparisonsApiFp(this.configuration).getComparisonList(vatNo, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update comparison
     * @param {CompareMetaObject} [compareMetaObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonsApi
     */
    public updateComparison(compareMetaObject?: CompareMetaObject, options?: any) {
        return ComparisonsApiFp(this.configuration).updateComparison(compareMetaObject, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Has right to see validation page in admin menu
         * @summary Has right to see papskilt page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardboardAccess: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configuration/cardboardAccess`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets configuration access status for user
         * @summary Gets configuration access status for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationAccess: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configuration/access`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Has right to see validation page in admin menu
         * @summary Has right to see validation page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExcelValidationAccess: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configuration/excelValidationAccess`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Has right to see import page in admin menu
         * @summary Has right to see import page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportAccess: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configuration/importAccess`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary get key
         * @param {string} key should use a enum here
         * @param {boolean} reload reload item instead of using cache
         * @param {boolean} [forceread] force that configuration item is read, even if cardboard is enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKey: async (key: string, reload: boolean, forceread?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getKey.');
            }
            // verify required parameter 'reload' is not null or undefined
            if (reload === null || reload === undefined) {
                throw new RequiredError('reload','Required parameter reload was null or undefined when calling getKey.');
            }
            const localVarPath = `/v1/configuration/{key}/{reload}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"reload"}}`, encodeURIComponent(String(reload)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (forceread !== undefined) {
                localVarQueryParameter['forceread'] = forceread;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Has right to see move calculation in admin menu
         * @summary Has right to see move calculation page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoveCalculationAccess: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configuration/moveCalculationAccess`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary get table content - used as hack
         * @param {string} tableName db tablename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTableRows: async (tableName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableName' is not null or undefined
            if (tableName === null || tableName === undefined) {
                throw new RequiredError('tableName','Required parameter tableName was null or undefined when calling getTableRows.');
            }
            const localVarPath = `/v1/configuration/getTable/{tableName}`
                .replace(`{${"tableName"}}`, encodeURIComponent(String(tableName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Has right to see ssi login
         * @summary Has right to see ssi login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showSSILogin: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configuration/showSSILogin`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Has right to see scope3 kategories in reductionTarget.vue
         * @summary Has right to see scope3 kategories in reductionTarget.vue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showScope3Categories: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configuration/showScope3Categories`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation updates a configuration key value
         * @summary update configuration
         * @param {string} key should use a enum here
         * @param {ConfigValue} [configValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKey: async (key: string, configValue?: ConfigValue, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling updateKey.');
            }
            const localVarPath = `/v1/configuration/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof configValue !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(configValue !== undefined ? configValue : {}) : (configValue || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export const ConfigurationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Has right to see validation page in admin menu
         * @summary Has right to see papskilt page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardboardAccess(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getCardboardAccess(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets configuration access status for user
         * @summary Gets configuration access status for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurationAccess(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getConfigurationAccess(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Has right to see validation page in admin menu
         * @summary Has right to see validation page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExcelValidationAccess(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getExcelValidationAccess(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Has right to see import page in admin menu
         * @summary Has right to see import page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportAccess(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getImportAccess(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary get key
         * @param {string} key should use a enum here
         * @param {boolean} reload reload item instead of using cache
         * @param {boolean} [forceread] force that configuration item is read, even if cardboard is enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKey(key: string, reload: boolean, forceread?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getKey(key, reload, forceread, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Has right to see move calculation in admin menu
         * @summary Has right to see move calculation page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoveCalculationAccess(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getMoveCalculationAccess(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary get table content - used as hack
         * @param {string} tableName db tablename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTableRows(tableName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableRow>>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).getTableRows(tableName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Has right to see ssi login
         * @summary Has right to see ssi login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showSSILogin(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).showSSILogin(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Has right to see scope3 kategories in reductionTarget.vue
         * @summary Has right to see scope3 kategories in reductionTarget.vue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showScope3Categories(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).showScope3Categories(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation updates a configuration key value
         * @summary update configuration
         * @param {string} key should use a enum here
         * @param {ConfigValue} [configValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKey(key: string, configValue?: ConfigValue, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ConfigurationApiAxiosParamCreator(configuration).updateKey(key, configValue, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConfigurationApi - factory interface
 * @export
 */
export const ConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Has right to see validation page in admin menu
         * @summary Has right to see papskilt page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardboardAccess(options?: any): AxiosPromise<boolean> {
            return ConfigurationApiFp(configuration).getCardboardAccess(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets configuration access status for user
         * @summary Gets configuration access status for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationAccess(options?: any): AxiosPromise<boolean> {
            return ConfigurationApiFp(configuration).getConfigurationAccess(options).then((request) => request(axios, basePath));
        },
        /**
         * Has right to see validation page in admin menu
         * @summary Has right to see validation page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExcelValidationAccess(options?: any): AxiosPromise<boolean> {
            return ConfigurationApiFp(configuration).getExcelValidationAccess(options).then((request) => request(axios, basePath));
        },
        /**
         * Has right to see import page in admin menu
         * @summary Has right to see import page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportAccess(options?: any): AxiosPromise<boolean> {
            return ConfigurationApiFp(configuration).getImportAccess(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary get key
         * @param {string} key should use a enum here
         * @param {boolean} reload reload item instead of using cache
         * @param {boolean} [forceread] force that configuration item is read, even if cardboard is enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKey(key: string, reload: boolean, forceread?: boolean, options?: any): AxiosPromise<string> {
            return ConfigurationApiFp(configuration).getKey(key, reload, forceread, options).then((request) => request(axios, basePath));
        },
        /**
         * Has right to see move calculation in admin menu
         * @summary Has right to see move calculation page in admin menu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoveCalculationAccess(options?: any): AxiosPromise<boolean> {
            return ConfigurationApiFp(configuration).getMoveCalculationAccess(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches all addresses related to a calculation by its unique ID
         * @summary get table content - used as hack
         * @param {string} tableName db tablename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTableRows(tableName: string, options?: any): AxiosPromise<Array<TableRow>> {
            return ConfigurationApiFp(configuration).getTableRows(tableName, options).then((request) => request(axios, basePath));
        },
        /**
         * Has right to see ssi login
         * @summary Has right to see ssi login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showSSILogin(options?: any): AxiosPromise<boolean> {
            return ConfigurationApiFp(configuration).showSSILogin(options).then((request) => request(axios, basePath));
        },
        /**
         * Has right to see scope3 kategories in reductionTarget.vue
         * @summary Has right to see scope3 kategories in reductionTarget.vue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showScope3Categories(options?: any): AxiosPromise<boolean> {
            return ConfigurationApiFp(configuration).showScope3Categories(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation updates a configuration key value
         * @summary update configuration
         * @param {string} key should use a enum here
         * @param {ConfigValue} [configValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKey(key: string, configValue?: ConfigValue, options?: any): AxiosPromise<string> {
            return ConfigurationApiFp(configuration).updateKey(key, configValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigurationApi extends BaseAPI {
    /**
     * Has right to see validation page in admin menu
     * @summary Has right to see papskilt page in admin menu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getCardboardAccess(options?: any) {
        return ConfigurationApiFp(this.configuration).getCardboardAccess(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets configuration access status for user
     * @summary Gets configuration access status for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getConfigurationAccess(options?: any) {
        return ConfigurationApiFp(this.configuration).getConfigurationAccess(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Has right to see validation page in admin menu
     * @summary Has right to see validation page in admin menu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getExcelValidationAccess(options?: any) {
        return ConfigurationApiFp(this.configuration).getExcelValidationAccess(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Has right to see import page in admin menu
     * @summary Has right to see import page in admin menu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getImportAccess(options?: any) {
        return ConfigurationApiFp(this.configuration).getImportAccess(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches all addresses related to a calculation by its unique ID
     * @summary get key
     * @param {string} key should use a enum here
     * @param {boolean} reload reload item instead of using cache
     * @param {boolean} [forceread] force that configuration item is read, even if cardboard is enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getKey(key: string, reload: boolean, forceread?: boolean, options?: any) {
        return ConfigurationApiFp(this.configuration).getKey(key, reload, forceread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Has right to see move calculation in admin menu
     * @summary Has right to see move calculation page in admin menu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getMoveCalculationAccess(options?: any) {
        return ConfigurationApiFp(this.configuration).getMoveCalculationAccess(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches all addresses related to a calculation by its unique ID
     * @summary get table content - used as hack
     * @param {string} tableName db tablename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getTableRows(tableName: string, options?: any) {
        return ConfigurationApiFp(this.configuration).getTableRows(tableName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Has right to see ssi login
     * @summary Has right to see ssi login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public showSSILogin(options?: any) {
        return ConfigurationApiFp(this.configuration).showSSILogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Has right to see scope3 kategories in reductionTarget.vue
     * @summary Has right to see scope3 kategories in reductionTarget.vue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public showScope3Categories(options?: any) {
        return ConfigurationApiFp(this.configuration).showScope3Categories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation updates a configuration key value
     * @summary update configuration
     * @param {string} key should use a enum here
     * @param {ConfigValue} [configValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public updateKey(key: string, configValue?: ConfigValue, options?: any) {
        return ConfigurationApiFp(this.configuration).updateKey(key, configValue, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ConsentsApi - axios parameter creator
 * @export
 */
export const ConsentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets consent for user/company
         * @summary Gets consent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsent: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/consents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets consent to yes
         * @summary Sets consent to yes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConsent: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/consents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Withdraw consents for person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawConsent: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/consents/withdraw`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentsApi - functional programming interface
 * @export
 */
export const ConsentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets consent for user/company
         * @summary Gets consent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsent(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await ConsentsApiAxiosParamCreator(configuration).getConsent(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Sets consent to yes
         * @summary Sets consent to yes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setConsent(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ConsentsApiAxiosParamCreator(configuration).setConsent(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Withdraw consents for person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withdrawConsent(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ConsentsApiAxiosParamCreator(configuration).withdrawConsent(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConsentsApi - factory interface
 * @export
 */
export const ConsentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Gets consent for user/company
         * @summary Gets consent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsent(options?: any): AxiosPromise<boolean> {
            return ConsentsApiFp(configuration).getConsent(options).then((request) => request(axios, basePath));
        },
        /**
         * Sets consent to yes
         * @summary Sets consent to yes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConsent(options?: any): AxiosPromise<string> {
            return ConsentsApiFp(configuration).setConsent(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Withdraw consents for person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawConsent(options?: any): AxiosPromise<string> {
            return ConsentsApiFp(configuration).withdrawConsent(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConsentsApi - object-oriented interface
 * @export
 * @class ConsentsApi
 * @extends {BaseAPI}
 */
export class ConsentsApi extends BaseAPI {
    /**
     * Gets consent for user/company
     * @summary Gets consent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public getConsent(options?: any) {
        return ConsentsApiFp(this.configuration).getConsent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets consent to yes
     * @summary Sets consent to yes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public setConsent(options?: any) {
        return ConsentsApiFp(this.configuration).setConsent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Withdraw consents for person
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public withdrawConsent(options?: any) {
        return ConsentsApiFp(this.configuration).withdrawConsent(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ContactPersonsApi - axios parameter creator
 * @export
 */
export const ContactPersonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation generates an Contact Person, one for each CVR (VAT number).
         * @summary Creates Contact Person for a companny
         * @param {ContactPerson} [contactPerson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactPerson: async (contactPerson?: ContactPerson, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/company/contactpersons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof contactPerson !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(contactPerson !== undefined ? contactPerson : {}) : (contactPerson || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation finds Contact Person, for a given CVR (VAT number).
         * @summary Fetch Contact Person for a companny
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContactPerson: async (vatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling fetchContactPerson.');
            }
            const localVarPath = `/v1/company/{vatNo}/contactpersons`
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation updates Contact Information, for a given CVR (VAT number).
         * @summary Updates Contact Information for a companny
         * @param {ContactPerson} [contactPerson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactPerson: async (contactPerson?: ContactPerson, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/company/contactpersons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof contactPerson !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(contactPerson !== undefined ? contactPerson : {}) : (contactPerson || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactPersonsApi - functional programming interface
 * @export
 */
export const ContactPersonsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation generates an Contact Person, one for each CVR (VAT number).
         * @summary Creates Contact Person for a companny
         * @param {ContactPerson} [contactPerson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContactPerson(contactPerson?: ContactPerson, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactPerson>> {
            const localVarAxiosArgs = await ContactPersonsApiAxiosParamCreator(configuration).createContactPerson(contactPerson, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation finds Contact Person, for a given CVR (VAT number).
         * @summary Fetch Contact Person for a companny
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchContactPerson(vatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactPerson>> {
            const localVarAxiosArgs = await ContactPersonsApiAxiosParamCreator(configuration).fetchContactPerson(vatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation updates Contact Information, for a given CVR (VAT number).
         * @summary Updates Contact Information for a companny
         * @param {ContactPerson} [contactPerson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContactPerson(contactPerson?: ContactPerson, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactPerson>> {
            const localVarAxiosArgs = await ContactPersonsApiAxiosParamCreator(configuration).updateContactPerson(contactPerson, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContactPersonsApi - factory interface
 * @export
 */
export const ContactPersonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation generates an Contact Person, one for each CVR (VAT number).
         * @summary Creates Contact Person for a companny
         * @param {ContactPerson} [contactPerson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactPerson(contactPerson?: ContactPerson, options?: any): AxiosPromise<ContactPerson> {
            return ContactPersonsApiFp(configuration).createContactPerson(contactPerson, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation finds Contact Person, for a given CVR (VAT number).
         * @summary Fetch Contact Person for a companny
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContactPerson(vatNo: string, options?: any): AxiosPromise<ContactPerson> {
            return ContactPersonsApiFp(configuration).fetchContactPerson(vatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation updates Contact Information, for a given CVR (VAT number).
         * @summary Updates Contact Information for a companny
         * @param {ContactPerson} [contactPerson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactPerson(contactPerson?: ContactPerson, options?: any): AxiosPromise<ContactPerson> {
            return ContactPersonsApiFp(configuration).updateContactPerson(contactPerson, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactPersonsApi - object-oriented interface
 * @export
 * @class ContactPersonsApi
 * @extends {BaseAPI}
 */
export class ContactPersonsApi extends BaseAPI {
    /**
     * This operation generates an Contact Person, one for each CVR (VAT number).
     * @summary Creates Contact Person for a companny
     * @param {ContactPerson} [contactPerson] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactPersonsApi
     */
    public createContactPerson(contactPerson?: ContactPerson, options?: any) {
        return ContactPersonsApiFp(this.configuration).createContactPerson(contactPerson, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation finds Contact Person, for a given CVR (VAT number).
     * @summary Fetch Contact Person for a companny
     * @param {string} vatNo VAT (CVR) number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactPersonsApi
     */
    public fetchContactPerson(vatNo: string, options?: any) {
        return ContactPersonsApiFp(this.configuration).fetchContactPerson(vatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation updates Contact Information, for a given CVR (VAT number).
     * @summary Updates Contact Information for a companny
     * @param {ContactPerson} [contactPerson] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactPersonsApi
     */
    public updateContactPerson(contactPerson?: ContactPerson, options?: any) {
        return ContactPersonsApiFp(this.configuration).updateContactPerson(contactPerson, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation returns a list of all countries for company information
         * @summary A list of all countries for company information is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCountries: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/countries`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation returns a list of all countries in thw world
         * @summary A list of all countries is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCountriesAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/countriesall`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation returns a list of all countries for company information
         * @summary A list of all countries for company information is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchCountries(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Countries>> {
            const localVarAxiosArgs = await CountriesApiAxiosParamCreator(configuration).fetchCountries(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation returns a list of all countries in thw world
         * @summary A list of all countries is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchCountriesAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountriesWithLocalizedNames>> {
            const localVarAxiosArgs = await CountriesApiAxiosParamCreator(configuration).fetchCountriesAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation returns a list of all countries for company information
         * @summary A list of all countries for company information is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCountries(options?: any): AxiosPromise<Countries> {
            return CountriesApiFp(configuration).fetchCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation returns a list of all countries in thw world
         * @summary A list of all countries is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCountriesAll(options?: any): AxiosPromise<CountriesWithLocalizedNames> {
            return CountriesApiFp(configuration).fetchCountriesAll(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI {
    /**
     * This operation returns a list of all countries for company information
     * @summary A list of all countries for company information is returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public fetchCountries(options?: any) {
        return CountriesApiFp(this.configuration).fetchCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation returns a list of all countries in thw world
     * @summary A list of all countries is returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public fetchCountriesAll(options?: any) {
        return CountriesApiFp(this.configuration).fetchCountriesAll(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EmissionsfactorImportApi - axios parameter creator
 * @export
 */
export const EmissionsfactorImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * facilitate a kk2 unique key to not so unique excel mapping
         * @summary create emission_coeffcieint_excel_mapping table
         * @param {string} masterKey The unique EMF master key eg. EMF_23
         * @param {string} excelKey The hopefully unique excel key, not not nessacary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExcelMapping: async (masterKey: string, excelKey: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterKey' is not null or undefined
            if (masterKey === null || masterKey === undefined) {
                throw new RequiredError('masterKey','Required parameter masterKey was null or undefined when calling createExcelMapping.');
            }
            // verify required parameter 'excelKey' is not null or undefined
            if (excelKey === null || excelKey === undefined) {
                throw new RequiredError('excelKey','Required parameter excelKey was null or undefined when calling createExcelMapping.');
            }
            const localVarPath = `/v1/emissionsfactor/createExcelMapping/{masterKey}/{excelKey}`
                .replace(`{${"masterKey"}}`, encodeURIComponent(String(masterKey)))
                .replace(`{${"excelKey"}}`, encodeURIComponent(String(excelKey)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation deletes all EMC
         * @summary Delete EMC for year and version
         * @param {number} year 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEMC: async (year: number, version: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling deleteEMC.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling deleteEMC.');
            }
            const localVarPath = `/v1/emissionsfactor/deleteEMC/{year}/{version}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation deletes an item
         * @summary Delete item i table emission_coefficient_excel_mapping
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExcelMapping: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteExcelMapping.');
            }
            const localVarPath = `/v1/emissionsfactor/deleteExcelMapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returning a sql string
         * @summary Export EMC to EMF mappings as environment nonspecific SQL update stamements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEMCToEMFMappingUpdates: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/exportEMCToEMFMappingUpdates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returning a sql string
         * @summary Export the chosen EMF year and version to a sql string
         * @param {number} year year for export
         * @param {number} version version for export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEMF: async (year: number, version: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling exportEMF.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportEMF.');
            }
            const localVarPath = `/v1/emissionsfactor/exportEMF/{year}/{version}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returning a sql string
         * @summary Export EMF and enum_master data tables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEMFMasterdata: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/exportEMFMasterdata`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returning a sql string
         * @summary Export the emission_coefficient_excel_mapping rows as insert/updates to sql string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMapping: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/exportMapping`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of EMC data
         * @param {boolean} onlyDK only return dk emc
         * @param {boolean} onlyNewestVersion Take newest version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEMF: async (onlyDK: boolean, onlyNewestVersion: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onlyDK' is not null or undefined
            if (onlyDK === null || onlyDK === undefined) {
                throw new RequiredError('onlyDK','Required parameter onlyDK was null or undefined when calling getEMF.');
            }
            // verify required parameter 'onlyNewestVersion' is not null or undefined
            if (onlyNewestVersion === null || onlyNewestVersion === undefined) {
                throw new RequiredError('onlyNewestVersion','Required parameter onlyNewestVersion was null or undefined when calling getEMF.');
            }
            const localVarPath = `/v1/emissionsfactor/getEMF/{onlyDK}/{onlyNewestVersion}`
                .replace(`{${"onlyDK"}}`, encodeURIComponent(String(onlyDK)))
                .replace(`{${"onlyNewestVersion"}}`, encodeURIComponent(String(onlyNewestVersion)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * null
         * @summary Get List af EMF masterdata
         * @param {number} emissionCoefficientVersionId Version info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEMFMasterdata: async (emissionCoefficientVersionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emissionCoefficientVersionId' is not null or undefined
            if (emissionCoefficientVersionId === null || emissionCoefficientVersionId === undefined) {
                throw new RequiredError('emissionCoefficientVersionId','Required parameter emissionCoefficientVersionId was null or undefined when calling getEMFMasterdata.');
            }
            const localVarPath = `/v1/emissionsfactor/getEMFMasterdata/{emissionCoefficientVersionId}`
                .replace(`{${"emissionCoefficientVersionId"}}`, encodeURIComponent(String(emissionCoefficientVersionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * null
         * @summary Get List af EMF emission_coefficient_excel_mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExcelMappingdata: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/getExcelMappingdata`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * null
         * @summary Are user allowed to click on Import button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportPermission: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/importPermission`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * return list of Excel keys not mapped and therefore unknown in kk2
         * @summary List of unmapped Excel keys
         * @param {any} [file] 
         * @param {string} [sheetName] name of the sheet to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnmappedExcelKeys: async (file?: any, sheetName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/unmappedExcelKeys`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (sheetName !== undefined) { 
                localVarFormParams.append('sheetName', sheetName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import Excel file, or if boolean sat the only validate.
         * @summary Import EMF Excel file
         * @param {any} [file] 
         * @param {string} [year] year
         * @param {string} [version] what version to import into
         * @param {string} [isForecast] is a forecast 1 &#x3D; true else false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEMF: async (file?: any, year?: string, version?: string, isForecast?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/importEMF`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (year !== undefined) { 
                localVarFormParams.append('year', year as any);
            }
    
            if (version !== undefined) { 
                localVarFormParams.append('version', version as any);
            }
    
            if (isForecast !== undefined) { 
                localVarFormParams.append('isForecast', isForecast as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returning a sql string
         * @summary List of import validation errors
         * @param {number} importFileId The unique import file id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importValidationErrors: async (importFileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'importFileId' is not null or undefined
            if (importFileId === null || importFileId === undefined) {
                throw new RequiredError('importFileId','Required parameter importFileId was null or undefined when calling importValidationErrors.');
            }
            const localVarPath = `/v1/emissionsfactor/ImportValidationErrors/{importFileId}`
                .replace(`{${"importFileId"}}`, encodeURIComponent(String(importFileId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returning a sql string
         * @summary List of pending import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingImportFiles: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/pendingImportFiles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * validate all tabs in Excel file
         * @summary validate EMF Excel file
         * @param {any} [file] 
         * @param {string} [sheetName] sheetName, if empty validates all sheets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExcel: async (file?: any, sheetName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/emissionsfactor/validateExcel`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (sheetName !== undefined) { 
                localVarFormParams.append('sheetName', sheetName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmissionsfactorImportApi - functional programming interface
 * @export
 */
export const EmissionsfactorImportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * facilitate a kk2 unique key to not so unique excel mapping
         * @summary create emission_coeffcieint_excel_mapping table
         * @param {string} masterKey The unique EMF master key eg. EMF_23
         * @param {string} excelKey The hopefully unique excel key, not not nessacary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExcelMapping(masterKey: string, excelKey: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).createExcelMapping(masterKey, excelKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation deletes all EMC
         * @summary Delete EMC for year and version
         * @param {number} year 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEMC(year: number, version: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).deleteEMC(year, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation deletes an item
         * @summary Delete item i table emission_coefficient_excel_mapping
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExcelMapping(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).deleteExcelMapping(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returning a sql string
         * @summary Export EMC to EMF mappings as environment nonspecific SQL update stamements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEMCToEMFMappingUpdates(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).exportEMCToEMFMappingUpdates(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returning a sql string
         * @summary Export the chosen EMF year and version to a sql string
         * @param {number} year year for export
         * @param {number} version version for export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEMF(year: number, version: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).exportEMF(year, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returning a sql string
         * @summary Export EMF and enum_master data tables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEMFMasterdata(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).exportEMFMasterdata(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returning a sql string
         * @summary Export the emission_coefficient_excel_mapping rows as insert/updates to sql string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMapping(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).exportMapping(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of EMC data
         * @param {boolean} onlyDK only return dk emc
         * @param {boolean} onlyNewestVersion Take newest version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEMF(onlyDK: boolean, onlyNewestVersion: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmissionCoefficientOverview>>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).getEMF(onlyDK, onlyNewestVersion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * null
         * @summary Get List af EMF masterdata
         * @param {number} emissionCoefficientVersionId Version info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEMFMasterdata(emissionCoefficientVersionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EMFMasterdata>>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).getEMFMasterdata(emissionCoefficientVersionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * null
         * @summary Get List af EMF emission_coefficient_excel_mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExcelMappingdata(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExcelMappingdata>>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).getExcelMappingdata(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * null
         * @summary Are user allowed to click on Import button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportPermission(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportPermission>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).getImportPermission(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * return list of Excel keys not mapped and therefore unknown in kk2
         * @summary List of unmapped Excel keys
         * @param {any} [file] 
         * @param {string} [sheetName] name of the sheet to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnmappedExcelKeys(file?: any, sheetName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExcelRow>>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).getUnmappedExcelKeys(file, sheetName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Import Excel file, or if boolean sat the only validate.
         * @summary Import EMF Excel file
         * @param {any} [file] 
         * @param {string} [year] year
         * @param {string} [version] what version to import into
         * @param {string} [isForecast] is a forecast 1 &#x3D; true else false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importEMF(file?: any, year?: string, version?: string, isForecast?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidationError>>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).importEMF(file, year, version, isForecast, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returning a sql string
         * @summary List of import validation errors
         * @param {number} importFileId The unique import file id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importValidationErrors(importFileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImportValidationError>>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).importValidationErrors(importFileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returning a sql string
         * @summary List of pending import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pendingImportFiles(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingImportFile>>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).pendingImportFiles(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * validate all tabs in Excel file
         * @summary validate EMF Excel file
         * @param {any} [file] 
         * @param {string} [sheetName] sheetName, if empty validates all sheets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateExcel(file?: any, sheetName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidationError>>> {
            const localVarAxiosArgs = await EmissionsfactorImportApiAxiosParamCreator(configuration).validateExcel(file, sheetName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EmissionsfactorImportApi - factory interface
 * @export
 */
export const EmissionsfactorImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * facilitate a kk2 unique key to not so unique excel mapping
         * @summary create emission_coeffcieint_excel_mapping table
         * @param {string} masterKey The unique EMF master key eg. EMF_23
         * @param {string} excelKey The hopefully unique excel key, not not nessacary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExcelMapping(masterKey: string, excelKey: string, options?: any): AxiosPromise<void> {
            return EmissionsfactorImportApiFp(configuration).createExcelMapping(masterKey, excelKey, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation deletes all EMC
         * @summary Delete EMC for year and version
         * @param {number} year 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEMC(year: number, version: number, options?: any): AxiosPromise<string> {
            return EmissionsfactorImportApiFp(configuration).deleteEMC(year, version, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation deletes an item
         * @summary Delete item i table emission_coefficient_excel_mapping
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExcelMapping(id: number, options?: any): AxiosPromise<void> {
            return EmissionsfactorImportApiFp(configuration).deleteExcelMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         * returning a sql string
         * @summary Export EMC to EMF mappings as environment nonspecific SQL update stamements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEMCToEMFMappingUpdates(options?: any): AxiosPromise<string> {
            return EmissionsfactorImportApiFp(configuration).exportEMCToEMFMappingUpdates(options).then((request) => request(axios, basePath));
        },
        /**
         * returning a sql string
         * @summary Export the chosen EMF year and version to a sql string
         * @param {number} year year for export
         * @param {number} version version for export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEMF(year: number, version: number, options?: any): AxiosPromise<string> {
            return EmissionsfactorImportApiFp(configuration).exportEMF(year, version, options).then((request) => request(axios, basePath));
        },
        /**
         * returning a sql string
         * @summary Export EMF and enum_master data tables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEMFMasterdata(options?: any): AxiosPromise<string> {
            return EmissionsfactorImportApiFp(configuration).exportEMFMasterdata(options).then((request) => request(axios, basePath));
        },
        /**
         * returning a sql string
         * @summary Export the emission_coefficient_excel_mapping rows as insert/updates to sql string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMapping(options?: any): AxiosPromise<string> {
            return EmissionsfactorImportApiFp(configuration).exportMapping(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of EMC data
         * @param {boolean} onlyDK only return dk emc
         * @param {boolean} onlyNewestVersion Take newest version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEMF(onlyDK: boolean, onlyNewestVersion: boolean, options?: any): AxiosPromise<Array<EmissionCoefficientOverview>> {
            return EmissionsfactorImportApiFp(configuration).getEMF(onlyDK, onlyNewestVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * null
         * @summary Get List af EMF masterdata
         * @param {number} emissionCoefficientVersionId Version info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEMFMasterdata(emissionCoefficientVersionId: number, options?: any): AxiosPromise<Array<EMFMasterdata>> {
            return EmissionsfactorImportApiFp(configuration).getEMFMasterdata(emissionCoefficientVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * null
         * @summary Get List af EMF emission_coefficient_excel_mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExcelMappingdata(options?: any): AxiosPromise<Array<ExcelMappingdata>> {
            return EmissionsfactorImportApiFp(configuration).getExcelMappingdata(options).then((request) => request(axios, basePath));
        },
        /**
         * null
         * @summary Are user allowed to click on Import button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportPermission(options?: any): AxiosPromise<ImportPermission> {
            return EmissionsfactorImportApiFp(configuration).getImportPermission(options).then((request) => request(axios, basePath));
        },
        /**
         * return list of Excel keys not mapped and therefore unknown in kk2
         * @summary List of unmapped Excel keys
         * @param {any} [file] 
         * @param {string} [sheetName] name of the sheet to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnmappedExcelKeys(file?: any, sheetName?: string, options?: any): AxiosPromise<Array<ExcelRow>> {
            return EmissionsfactorImportApiFp(configuration).getUnmappedExcelKeys(file, sheetName, options).then((request) => request(axios, basePath));
        },
        /**
         * Import Excel file, or if boolean sat the only validate.
         * @summary Import EMF Excel file
         * @param {any} [file] 
         * @param {string} [year] year
         * @param {string} [version] what version to import into
         * @param {string} [isForecast] is a forecast 1 &#x3D; true else false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEMF(file?: any, year?: string, version?: string, isForecast?: string, options?: any): AxiosPromise<Array<ValidationError>> {
            return EmissionsfactorImportApiFp(configuration).importEMF(file, year, version, isForecast, options).then((request) => request(axios, basePath));
        },
        /**
         * returning a sql string
         * @summary List of import validation errors
         * @param {number} importFileId The unique import file id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importValidationErrors(importFileId: number, options?: any): AxiosPromise<Array<ImportValidationError>> {
            return EmissionsfactorImportApiFp(configuration).importValidationErrors(importFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * returning a sql string
         * @summary List of pending import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingImportFiles(options?: any): AxiosPromise<Array<PendingImportFile>> {
            return EmissionsfactorImportApiFp(configuration).pendingImportFiles(options).then((request) => request(axios, basePath));
        },
        /**
         * validate all tabs in Excel file
         * @summary validate EMF Excel file
         * @param {any} [file] 
         * @param {string} [sheetName] sheetName, if empty validates all sheets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExcel(file?: any, sheetName?: string, options?: any): AxiosPromise<Array<ValidationError>> {
            return EmissionsfactorImportApiFp(configuration).validateExcel(file, sheetName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmissionsfactorImportApi - object-oriented interface
 * @export
 * @class EmissionsfactorImportApi
 * @extends {BaseAPI}
 */
export class EmissionsfactorImportApi extends BaseAPI {
    /**
     * facilitate a kk2 unique key to not so unique excel mapping
     * @summary create emission_coeffcieint_excel_mapping table
     * @param {string} masterKey The unique EMF master key eg. EMF_23
     * @param {string} excelKey The hopefully unique excel key, not not nessacary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public createExcelMapping(masterKey: string, excelKey: string, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).createExcelMapping(masterKey, excelKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation deletes all EMC
     * @summary Delete EMC for year and version
     * @param {number} year 
     * @param {number} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public deleteEMC(year: number, version: number, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).deleteEMC(year, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation deletes an item
     * @summary Delete item i table emission_coefficient_excel_mapping
     * @param {number} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public deleteExcelMapping(id: number, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).deleteExcelMapping(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returning a sql string
     * @summary Export EMC to EMF mappings as environment nonspecific SQL update stamements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public exportEMCToEMFMappingUpdates(options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).exportEMCToEMFMappingUpdates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returning a sql string
     * @summary Export the chosen EMF year and version to a sql string
     * @param {number} year year for export
     * @param {number} version version for export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public exportEMF(year: number, version: number, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).exportEMF(year, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returning a sql string
     * @summary Export EMF and enum_master data tables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public exportEMFMasterdata(options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).exportEMFMasterdata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returning a sql string
     * @summary Export the emission_coefficient_excel_mapping rows as insert/updates to sql string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public exportMapping(options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).exportMapping(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of EMC data
     * @param {boolean} onlyDK only return dk emc
     * @param {boolean} onlyNewestVersion Take newest version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public getEMF(onlyDK: boolean, onlyNewestVersion: boolean, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).getEMF(onlyDK, onlyNewestVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * null
     * @summary Get List af EMF masterdata
     * @param {number} emissionCoefficientVersionId Version info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public getEMFMasterdata(emissionCoefficientVersionId: number, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).getEMFMasterdata(emissionCoefficientVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * null
     * @summary Get List af EMF emission_coefficient_excel_mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public getExcelMappingdata(options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).getExcelMappingdata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * null
     * @summary Are user allowed to click on Import button
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public getImportPermission(options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).getImportPermission(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * return list of Excel keys not mapped and therefore unknown in kk2
     * @summary List of unmapped Excel keys
     * @param {any} [file] 
     * @param {string} [sheetName] name of the sheet to import
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public getUnmappedExcelKeys(file?: any, sheetName?: string, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).getUnmappedExcelKeys(file, sheetName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import Excel file, or if boolean sat the only validate.
     * @summary Import EMF Excel file
     * @param {any} [file] 
     * @param {string} [year] year
     * @param {string} [version] what version to import into
     * @param {string} [isForecast] is a forecast 1 &#x3D; true else false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public importEMF(file?: any, year?: string, version?: string, isForecast?: string, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).importEMF(file, year, version, isForecast, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returning a sql string
     * @summary List of import validation errors
     * @param {number} importFileId The unique import file id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public importValidationErrors(importFileId: number, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).importValidationErrors(importFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returning a sql string
     * @summary List of pending import
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public pendingImportFiles(options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).pendingImportFiles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * validate all tabs in Excel file
     * @summary validate EMF Excel file
     * @param {any} [file] 
     * @param {string} [sheetName] sheetName, if empty validates all sheets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionsfactorImportApi
     */
    public validateExcel(file?: any, sheetName?: string, options?: any) {
        return EmissionsfactorImportApiFp(this.configuration).validateExcel(file, sheetName, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation deletes a file
         * @summary Delete file
         * @param {number} fileId The file identifier
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (fileId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling deleteFile.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling deleteFile.');
            }
            const localVarPath = `/v1/files/{fileId}/{thirdpartyVatNo}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation returns a the file based on file id
         * @summary Fetches files with based on file id
         * @param {number} fileId File id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileByFileId: async (fileId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling getFileByFileId.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getFileByFileId.');
            }
            const localVarPath = `/v1/files/{fileId}/{thirdpartyVatNo}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation returns a list of files associated to calculation line id
         * @summary Fetches files with based on calculation line id
         * @param {number} calculationLineId Calculation line id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesByCalculationLineId: async (calculationLineId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationLineId' is not null or undefined
            if (calculationLineId === null || calculationLineId === undefined) {
                throw new RequiredError('calculationLineId','Required parameter calculationLineId was null or undefined when calling getFilesByCalculationLineId.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getFilesByCalculationLineId.');
            }
            const localVarPath = `/v1/files/calculations/{calculationLineId}/{thirdpartyVatNo}`
                .replace(`{${"calculationLineId"}}`, encodeURIComponent(String(calculationLineId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation deletes a file
         * @summary Delete file
         * @param {number} fileId The file identifier
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(fileId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FilesApiAxiosParamCreator(configuration).deleteFile(fileId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation returns a the file based on file id
         * @summary Fetches files with based on file id
         * @param {number} fileId File id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileByFileId(fileId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResource>> {
            const localVarAxiosArgs = await FilesApiAxiosParamCreator(configuration).getFileByFileId(fileId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation returns a list of files associated to calculation line id
         * @summary Fetches files with based on calculation line id
         * @param {number} calculationLineId Calculation line id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilesByCalculationLineId(calculationLineId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileMessages>> {
            const localVarAxiosArgs = await FilesApiAxiosParamCreator(configuration).getFilesByCalculationLineId(calculationLineId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation deletes a file
         * @summary Delete file
         * @param {number} fileId The file identifier
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(fileId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<void> {
            return FilesApiFp(configuration).deleteFile(fileId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation returns a the file based on file id
         * @summary Fetches files with based on file id
         * @param {number} fileId File id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileByFileId(fileId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<FileResource> {
            return FilesApiFp(configuration).getFileByFileId(fileId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation returns a list of files associated to calculation line id
         * @summary Fetches files with based on calculation line id
         * @param {number} calculationLineId Calculation line id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesByCalculationLineId(calculationLineId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<FileMessages> {
            return FilesApiFp(configuration).getFilesByCalculationLineId(calculationLineId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
    /**
     * This operation deletes a file
     * @summary Delete file
     * @param {number} fileId The file identifier
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public deleteFile(fileId: number, thirdpartyVatNo: string, options?: any) {
        return FilesApiFp(this.configuration).deleteFile(fileId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation returns a the file based on file id
     * @summary Fetches files with based on file id
     * @param {number} fileId File id
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public getFileByFileId(fileId: number, thirdpartyVatNo: string, options?: any) {
        return FilesApiFp(this.configuration).getFileByFileId(fileId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation returns a list of files associated to calculation line id
     * @summary Fetches files with based on calculation line id
     * @param {number} calculationLineId Calculation line id
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public getFilesByCalculationLineId(calculationLineId: number, thirdpartyVatNo: string, options?: any) {
        return FilesApiFp(this.configuration).getFilesByCalculationLineId(calculationLineId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ForecastApi - axios parameter creator
 * @export
 */
export const ForecastApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create forecast aka metadata and a number of calculation records
         * @param {ForecastInfo} [forecastInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForecast: async (forecastInfo?: ForecastInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/forecast`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof forecastInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(forecastInfo !== undefined ? forecastInfo : {}) : (forecastInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete forecast
         * @param {number} forecastId forecastId of forecast to remove
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteForecast: async (forecastId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forecastId' is not null or undefined
            if (forecastId === null || forecastId === undefined) {
                throw new RequiredError('forecastId','Required parameter forecastId was null or undefined when calling deleteForecast.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling deleteForecast.');
            }
            const localVarPath = `/v1/forecast/{forecastId}/{thirdpartyVatNo}`
                .replace(`{${"forecastId"}}`, encodeURIComponent(String(forecastId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exports the results of the given forecast to excel
         * @param {number} forecastId forecast id
         * @param {string} thirdpartyVatNo if set use this when export
         * @param {string} countrycode country code, default is DK
         * @param {string} environment prod, dev etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportToExcel2: async (forecastId: number, thirdpartyVatNo: string, countrycode: string, environment: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forecastId' is not null or undefined
            if (forecastId === null || forecastId === undefined) {
                throw new RequiredError('forecastId','Required parameter forecastId was null or undefined when calling exportToExcel2.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling exportToExcel2.');
            }
            // verify required parameter 'countrycode' is not null or undefined
            if (countrycode === null || countrycode === undefined) {
                throw new RequiredError('countrycode','Required parameter countrycode was null or undefined when calling exportToExcel2.');
            }
            // verify required parameter 'environment' is not null or undefined
            if (environment === null || environment === undefined) {
                throw new RequiredError('environment','Required parameter environment was null or undefined when calling exportToExcel2.');
            }
            const localVarPath = `/v1/forecast/export/{forecastId}/{thirdpartyVatNo}/{countrycode}/{environment}`
                .replace(`{${"forecastId"}}`, encodeURIComponent(String(forecastId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)))
                .replace(`{${"countrycode"}}`, encodeURIComponent(String(countrycode)))
                .replace(`{${"environment"}}`, encodeURIComponent(String(environment)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches a forecast with Calculations grouped by grouping (subject).
         * @summary Get all the calculations of a forecast, plus metadata given id
         * @param {number} forecastId forecast id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecast: async (forecastId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forecastId' is not null or undefined
            if (forecastId === null || forecastId === undefined) {
                throw new RequiredError('forecastId','Required parameter forecastId was null or undefined when calling getForecast.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getForecast.');
            }
            const localVarPath = `/v1/forecast/{forecastId}/{thirdpartyVatNo}`
                .replace(`{${"forecastId"}}`, encodeURIComponent(String(forecastId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches a forecast with Calculations grouped by grouping (subject).
         * @summary Get all the forecasts given a id
         * @param {string} vatNo VAT (CVR) number
         * @param {string} contactPersonRID 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecasts: async (vatNo: string, contactPersonRID: string, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling getForecasts.');
            }
            // verify required parameter 'contactPersonRID' is not null or undefined
            if (contactPersonRID === null || contactPersonRID === undefined) {
                throw new RequiredError('contactPersonRID','Required parameter contactPersonRID was null or undefined when calling getForecasts.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getForecasts.');
            }
            const localVarPath = `/v1/forecasts/{vatNo}/{contactPersonRID}/{thirdpartyVatNo}`
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)))
                .replace(`{${"contactPersonRID"}}`, encodeURIComponent(String(contactPersonRID)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update forecast aka metadata and a number of calculation records
         * @param {ForecastInfo} [forecastInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateForecast: async (forecastInfo?: ForecastInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/forecast`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof forecastInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(forecastInfo !== undefined ? forecastInfo : {}) : (forecastInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForecastApi - functional programming interface
 * @export
 */
export const ForecastApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create forecast aka metadata and a number of calculation records
         * @param {ForecastInfo} [forecastInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createForecast(forecastInfo?: ForecastInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForecastHeaderResult>> {
            const localVarAxiosArgs = await ForecastApiAxiosParamCreator(configuration).createForecast(forecastInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete forecast
         * @param {number} forecastId forecastId of forecast to remove
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteForecast(forecastId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ForecastApiAxiosParamCreator(configuration).deleteForecast(forecastId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Exports the results of the given forecast to excel
         * @param {number} forecastId forecast id
         * @param {string} thirdpartyVatNo if set use this when export
         * @param {string} countrycode country code, default is DK
         * @param {string} environment prod, dev etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportToExcel2(forecastId: number, thirdpartyVatNo: string, countrycode: string, environment: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ForecastApiAxiosParamCreator(configuration).exportToExcel2(forecastId, thirdpartyVatNo, countrycode, environment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches a forecast with Calculations grouped by grouping (subject).
         * @summary Get all the calculations of a forecast, plus metadata given id
         * @param {number} forecastId forecast id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecast(forecastId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForecastResults>> {
            const localVarAxiosArgs = await ForecastApiAxiosParamCreator(configuration).getForecast(forecastId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches a forecast with Calculations grouped by grouping (subject).
         * @summary Get all the forecasts given a id
         * @param {string} vatNo VAT (CVR) number
         * @param {string} contactPersonRID 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecasts(vatNo: string, contactPersonRID: string, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Forecasts>> {
            const localVarAxiosArgs = await ForecastApiAxiosParamCreator(configuration).getForecasts(vatNo, contactPersonRID, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary update forecast aka metadata and a number of calculation records
         * @param {ForecastInfo} [forecastInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateForecast(forecastInfo?: ForecastInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForecastHeaderResult>> {
            const localVarAxiosArgs = await ForecastApiAxiosParamCreator(configuration).updateForecast(forecastInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ForecastApi - factory interface
 * @export
 */
export const ForecastApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary create forecast aka metadata and a number of calculation records
         * @param {ForecastInfo} [forecastInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForecast(forecastInfo?: ForecastInfo, options?: any): AxiosPromise<ForecastHeaderResult> {
            return ForecastApiFp(configuration).createForecast(forecastInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete forecast
         * @param {number} forecastId forecastId of forecast to remove
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteForecast(forecastId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<string> {
            return ForecastApiFp(configuration).deleteForecast(forecastId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exports the results of the given forecast to excel
         * @param {number} forecastId forecast id
         * @param {string} thirdpartyVatNo if set use this when export
         * @param {string} countrycode country code, default is DK
         * @param {string} environment prod, dev etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportToExcel2(forecastId: number, thirdpartyVatNo: string, countrycode: string, environment: string, options?: any): AxiosPromise<any> {
            return ForecastApiFp(configuration).exportToExcel2(forecastId, thirdpartyVatNo, countrycode, environment, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches a forecast with Calculations grouped by grouping (subject).
         * @summary Get all the calculations of a forecast, plus metadata given id
         * @param {number} forecastId forecast id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecast(forecastId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<ForecastResults> {
            return ForecastApiFp(configuration).getForecast(forecastId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches a forecast with Calculations grouped by grouping (subject).
         * @summary Get all the forecasts given a id
         * @param {string} vatNo VAT (CVR) number
         * @param {string} contactPersonRID 
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecasts(vatNo: string, contactPersonRID: string, thirdpartyVatNo: string, options?: any): AxiosPromise<Forecasts> {
            return ForecastApiFp(configuration).getForecasts(vatNo, contactPersonRID, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update forecast aka metadata and a number of calculation records
         * @param {ForecastInfo} [forecastInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateForecast(forecastInfo?: ForecastInfo, options?: any): AxiosPromise<ForecastHeaderResult> {
            return ForecastApiFp(configuration).updateForecast(forecastInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForecastApi - object-oriented interface
 * @export
 * @class ForecastApi
 * @extends {BaseAPI}
 */
export class ForecastApi extends BaseAPI {
    /**
     * 
     * @summary create forecast aka metadata and a number of calculation records
     * @param {ForecastInfo} [forecastInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public createForecast(forecastInfo?: ForecastInfo, options?: any) {
        return ForecastApiFp(this.configuration).createForecast(forecastInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete forecast
     * @param {number} forecastId forecastId of forecast to remove
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public deleteForecast(forecastId: number, thirdpartyVatNo: string, options?: any) {
        return ForecastApiFp(this.configuration).deleteForecast(forecastId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exports the results of the given forecast to excel
     * @param {number} forecastId forecast id
     * @param {string} thirdpartyVatNo if set use this when export
     * @param {string} countrycode country code, default is DK
     * @param {string} environment prod, dev etc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public exportToExcel2(forecastId: number, thirdpartyVatNo: string, countrycode: string, environment: string, options?: any) {
        return ForecastApiFp(this.configuration).exportToExcel2(forecastId, thirdpartyVatNo, countrycode, environment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches a forecast with Calculations grouped by grouping (subject).
     * @summary Get all the calculations of a forecast, plus metadata given id
     * @param {number} forecastId forecast id
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public getForecast(forecastId: number, thirdpartyVatNo: string, options?: any) {
        return ForecastApiFp(this.configuration).getForecast(forecastId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches a forecast with Calculations grouped by grouping (subject).
     * @summary Get all the forecasts given a id
     * @param {string} vatNo VAT (CVR) number
     * @param {string} contactPersonRID 
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public getForecasts(vatNo: string, contactPersonRID: string, thirdpartyVatNo: string, options?: any) {
        return ForecastApiFp(this.configuration).getForecasts(vatNo, contactPersonRID, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update forecast aka metadata and a number of calculation records
     * @param {ForecastInfo} [forecastInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public updateForecast(forecastInfo?: ForecastInfo, options?: any) {
        return ForecastApiFp(this.configuration).updateForecast(forecastInfo, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MiscellaneousApi - axios parameter creator
 * @export
 */
export const MiscellaneousApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retreives Info on used EMC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEMCStatistics: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/checkEmc`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MiscellaneousApi - functional programming interface
 * @export
 */
export const MiscellaneousApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retreives Info on used EMC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEMCStatistics(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await MiscellaneousApiAxiosParamCreator(configuration).getEMCStatistics(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MiscellaneousApi - factory interface
 * @export
 */
export const MiscellaneousApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Retreives Info on used EMC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEMCStatistics(options?: any): AxiosPromise<string> {
            return MiscellaneousApiFp(configuration).getEMCStatistics(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MiscellaneousApi - object-oriented interface
 * @export
 * @class MiscellaneousApi
 * @extends {BaseAPI}
 */
export class MiscellaneousApi extends BaseAPI {
    /**
     * 
     * @summary Retreives Info on used EMC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscellaneousApi
     */
    public getEMCStatistics(options?: any) {
        return MiscellaneousApiFp(this.configuration).getEMCStatistics(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MonitorApi - axios parameter creator
 * @export
 */
export const MonitorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns JA if server providing this Open API specification is up and dependent systems is also. Else NEJ.
         * @summary To test connection to klimakompasset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erduoppe: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/erduoppe`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shows overview of other systems in a table
         * @summary Get an overview of dependent systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overblik: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/erduoppe/overblik`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns OK if server providing this Open API specification is up
         * @summary To test connection to klimakompasset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/erduoppe/ping`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary return piwik account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        piwikAccountId: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/piwikAccountId`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitorApi - functional programming interface
 * @export
 */
export const MonitorApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns JA if server providing this Open API specification is up and dependent systems is also. Else NEJ.
         * @summary To test connection to klimakompasset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async erduoppe(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await MonitorApiAxiosParamCreator(configuration).erduoppe(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Shows overview of other systems in a table
         * @summary Get an overview of dependent systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overblik(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await MonitorApiAxiosParamCreator(configuration).overblik(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns OK if server providing this Open API specification is up
         * @summary To test connection to klimakompasset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ping(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await MonitorApiAxiosParamCreator(configuration).ping(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary return piwik account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async piwikAccountId(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await MonitorApiAxiosParamCreator(configuration).piwikAccountId(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MonitorApi - factory interface
 * @export
 */
export const MonitorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns JA if server providing this Open API specification is up and dependent systems is also. Else NEJ.
         * @summary To test connection to klimakompasset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erduoppe(options?: any): AxiosPromise<string> {
            return MonitorApiFp(configuration).erduoppe(options).then((request) => request(axios, basePath));
        },
        /**
         * Shows overview of other systems in a table
         * @summary Get an overview of dependent systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overblik(options?: any): AxiosPromise<string> {
            return MonitorApiFp(configuration).overblik(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns OK if server providing this Open API specification is up
         * @summary To test connection to klimakompasset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options?: any): AxiosPromise<string> {
            return MonitorApiFp(configuration).ping(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary return piwik account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        piwikAccountId(options?: any): AxiosPromise<string> {
            return MonitorApiFp(configuration).piwikAccountId(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MonitorApi - object-oriented interface
 * @export
 * @class MonitorApi
 * @extends {BaseAPI}
 */
export class MonitorApi extends BaseAPI {
    /**
     * Returns JA if server providing this Open API specification is up and dependent systems is also. Else NEJ.
     * @summary To test connection to klimakompasset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorApi
     */
    public erduoppe(options?: any) {
        return MonitorApiFp(this.configuration).erduoppe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shows overview of other systems in a table
     * @summary Get an overview of dependent systems
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorApi
     */
    public overblik(options?: any) {
        return MonitorApiFp(this.configuration).overblik(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns OK if server providing this Open API specification is up
     * @summary To test connection to klimakompasset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorApi
     */
    public ping(options?: any) {
        return MonitorApiFp(this.configuration).ping(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary return piwik account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorApi
     */
    public piwikAccountId(options?: any) {
        return MonitorApiFp(this.configuration).piwikAccountId(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NewsApi - axios parameter creator
 * @export
 */
export const NewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Get News that has been seen by user info
         * @param {string} contentfulId ident of the news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasBeenShown: async (contentfulId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'contentfulId' is not null or undefined
            if (contentfulId === null || contentfulId === undefined) {
                throw new RequiredError('contentfulId','Required parameter contentfulId was null or undefined when calling hasBeenShown.');
            }
            const localVarPath = `/v1/news/hasBeenShown/{contentfulId}`
                .replace(`{${"contentfulId"}}`, encodeURIComponent(String(contentfulId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches all News that has been marked as shown by the user.
         * @summary Get News that has been seen by user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasBeenShownAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/news/hasBeenShownAll`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set that a news items has been seen
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setShown: async (requestBody?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/news/setShown`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsApi - functional programming interface
 * @export
 */
export const NewsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Get News that has been seen by user info
         * @param {string} contentfulId ident of the news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasBeenShown(contentfulId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).hasBeenShown(contentfulId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches all News that has been marked as shown by the user.
         * @summary Get News that has been seen by user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasBeenShownAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<News>>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).hasBeenShownAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary set that a news items has been seen
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setShown(requestBody?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).setShown(requestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NewsApi - factory interface
 * @export
 */
export const NewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation fetches a Calculations grouped by grouping (subject).
         * @summary Get News that has been seen by user info
         * @param {string} contentfulId ident of the news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasBeenShown(contentfulId: string, options?: any): AxiosPromise<boolean> {
            return NewsApiFp(configuration).hasBeenShown(contentfulId, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches all News that has been marked as shown by the user.
         * @summary Get News that has been seen by user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasBeenShownAll(options?: any): AxiosPromise<Array<News>> {
            return NewsApiFp(configuration).hasBeenShownAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set that a news items has been seen
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setShown(requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return NewsApiFp(configuration).setShown(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewsApi - object-oriented interface
 * @export
 * @class NewsApi
 * @extends {BaseAPI}
 */
export class NewsApi extends BaseAPI {
    /**
     * This operation fetches a Calculations grouped by grouping (subject).
     * @summary Get News that has been seen by user info
     * @param {string} contentfulId ident of the news
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public hasBeenShown(contentfulId: string, options?: any) {
        return NewsApiFp(this.configuration).hasBeenShown(contentfulId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches all News that has been marked as shown by the user.
     * @summary Get News that has been seen by user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public hasBeenShownAll(options?: any) {
        return NewsApiFp(this.configuration).hasBeenShownAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set that a news items has been seen
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public setShown(requestBody?: Array<string>, options?: any) {
        return NewsApiFp(this.configuration).setShown(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification: async (id: number, rid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNotification.');
            }
            // verify required parameter 'rid' is not null or undefined
            if (rid === null || rid === undefined) {
                throw new RequiredError('rid','Required parameter rid was null or undefined when calling deleteNotification.');
            }
            const localVarPath = `/v1/notifications/delete/{id}/{rid}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * null
         * @summary Lidt of notifications to be shown for specific user
         * @param {string} vatNo 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (vatNo: string, rid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling getNotifications.');
            }
            // verify required parameter 'rid' is not null or undefined
            if (rid === null || rid === undefined) {
                throw new RequiredError('rid','Required parameter rid was null or undefined when calling getNotifications.');
            }
            const localVarPath = `/v1/notifications/{vatNo}/{rid}`
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotification(id: number, rid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).deleteNotification(id, rid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * null
         * @summary Lidt of notifications to be shown for specific user
         * @param {string} vatNo 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(vatNo: string, rid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).getNotifications(vatNo, rid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(id: number, rid: string, options?: any): AxiosPromise<string> {
            return NotificationsApiFp(configuration).deleteNotification(id, rid, options).then((request) => request(axios, basePath));
        },
        /**
         * null
         * @summary Lidt of notifications to be shown for specific user
         * @param {string} vatNo 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(vatNo: string, rid: string, options?: any): AxiosPromise<Array<Notification>> {
            return NotificationsApiFp(configuration).getNotifications(vatNo, rid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} rid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public deleteNotification(id: number, rid: string, options?: any) {
        return NotificationsApiFp(this.configuration).deleteNotification(id, rid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * null
     * @summary Lidt of notifications to be shown for specific user
     * @param {string} vatNo 
     * @param {string} rid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(vatNo: string, rid: string, options?: any) {
        return NotificationsApiFp(this.configuration).getNotifications(vatNo, rid, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProductionUnitsApi - axios parameter creator
 * @export
 */
export const ProductionUnitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation fetches one specefic Production Unit, calls service from ERST to fatch production unit for a given pNumber.
         * @summary Gets a specefic production unit (P-enheder)
         * @param {string} pNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionUnit: async (pNumber: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pNumber' is not null or undefined
            if (pNumber === null || pNumber === undefined) {
                throw new RequiredError('pNumber','Required parameter pNumber was null or undefined when calling getProductionUnit.');
            }
            const localVarPath = `/v1/productionunits/productionunit/{pNumber}`
                .replace(`{${"pNumber"}}`, encodeURIComponent(String(pNumber)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches all Production Units calls service from ERST to fatch all production units for a give vatNo.
         * @summary Gets a list of production units (P-enheder)
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionUnits: async (vatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatNo' is not null or undefined
            if (vatNo === null || vatNo === undefined) {
                throw new RequiredError('vatNo','Required parameter vatNo was null or undefined when calling getProductionUnits.');
            }
            const localVarPath = `/v1/productionunits/{vatNo}`
                .replace(`{${"vatNo"}}`, encodeURIComponent(String(vatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductionUnitsApi - functional programming interface
 * @export
 */
export const ProductionUnitsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation fetches one specefic Production Unit, calls service from ERST to fatch production unit for a given pNumber.
         * @summary Gets a specefic production unit (P-enheder)
         * @param {string} pNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionUnit(pNumber: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionUnit>> {
            const localVarAxiosArgs = await ProductionUnitsApiAxiosParamCreator(configuration).getProductionUnit(pNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This operation fetches all Production Units calls service from ERST to fatch all production units for a give vatNo.
         * @summary Gets a list of production units (P-enheder)
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionUnits(vatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionUnits>> {
            const localVarAxiosArgs = await ProductionUnitsApiAxiosParamCreator(configuration).getProductionUnits(vatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductionUnitsApi - factory interface
 * @export
 */
export const ProductionUnitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation fetches one specefic Production Unit, calls service from ERST to fatch production unit for a given pNumber.
         * @summary Gets a specefic production unit (P-enheder)
         * @param {string} pNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionUnit(pNumber: string, options?: any): AxiosPromise<ProductionUnit> {
            return ProductionUnitsApiFp(configuration).getProductionUnit(pNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches all Production Units calls service from ERST to fatch all production units for a give vatNo.
         * @summary Gets a list of production units (P-enheder)
         * @param {string} vatNo VAT (CVR) number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionUnits(vatNo: string, options?: any): AxiosPromise<ProductionUnits> {
            return ProductionUnitsApiFp(configuration).getProductionUnits(vatNo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductionUnitsApi - object-oriented interface
 * @export
 * @class ProductionUnitsApi
 * @extends {BaseAPI}
 */
export class ProductionUnitsApi extends BaseAPI {
    /**
     * This operation fetches one specefic Production Unit, calls service from ERST to fatch production unit for a given pNumber.
     * @summary Gets a specefic production unit (P-enheder)
     * @param {string} pNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionUnitsApi
     */
    public getProductionUnit(pNumber: string, options?: any) {
        return ProductionUnitsApiFp(this.configuration).getProductionUnit(pNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches all Production Units calls service from ERST to fatch all production units for a give vatNo.
     * @summary Gets a list of production units (P-enheder)
     * @param {string} vatNo VAT (CVR) number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionUnitsApi
     */
    public getProductionUnits(vatNo: string, options?: any) {
        return ProductionUnitsApiFp(this.configuration).getProductionUnits(vatNo, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ReductionTargetApi - axios parameter creator
 * @export
 */
export const ReductionTargetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create aka metadata and a number of calculation records
         * @param {ReductionInfo} [reductionInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReductionTarget: async (reductionInfo?: ReductionInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reductiontarget`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reductionInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reductionInfo !== undefined ? reductionInfo : {}) : (reductionInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete
         * @param {number} reductionTargetId id of item to remove
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReductionTarget: async (reductionTargetId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reductionTargetId' is not null or undefined
            if (reductionTargetId === null || reductionTargetId === undefined) {
                throw new RequiredError('reductionTargetId','Required parameter reductionTargetId was null or undefined when calling deleteReductionTarget.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling deleteReductionTarget.');
            }
            const localVarPath = `/v1/reductiontarget/{reductionTargetId}/{thirdpartyVatNo}`
                .replace(`{${"reductionTargetId"}}`, encodeURIComponent(String(reductionTargetId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get selected and all categories for reduction target id
         * @param {number} reductionTargetId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (reductionTargetId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reductionTargetId' is not null or undefined
            if (reductionTargetId === null || reductionTargetId === undefined) {
                throw new RequiredError('reductionTargetId','Required parameter reductionTargetId was null or undefined when calling getCategories.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getCategories.');
            }
            const localVarPath = `/v1/reductiontarget/categories/{reductionTargetId}/{thirdpartyVatNo}`
                .replace(`{${"reductionTargetId"}}`, encodeURIComponent(String(reductionTargetId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get specific item
         * @param {number} reductionTargetId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReductionTarget: async (reductionTargetId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reductionTargetId' is not null or undefined
            if (reductionTargetId === null || reductionTargetId === undefined) {
                throw new RequiredError('reductionTargetId','Required parameter reductionTargetId was null or undefined when calling getReductionTarget.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getReductionTarget.');
            }
            const localVarPath = `/v1/reductiontarget/{reductionTargetId}/{thirdpartyVatNo}`
                .replace(`{${"reductionTargetId"}}`, encodeURIComponent(String(reductionTargetId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get specific item
         * @param {number} forecastId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReductionTargets: async (forecastId: number, thirdpartyVatNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forecastId' is not null or undefined
            if (forecastId === null || forecastId === undefined) {
                throw new RequiredError('forecastId','Required parameter forecastId was null or undefined when calling getReductionTargets.');
            }
            // verify required parameter 'thirdpartyVatNo' is not null or undefined
            if (thirdpartyVatNo === null || thirdpartyVatNo === undefined) {
                throw new RequiredError('thirdpartyVatNo','Required parameter thirdpartyVatNo was null or undefined when calling getReductionTargets.');
            }
            const localVarPath = `/v1/reductiontargets/{forecastId}/{thirdpartyVatNo}`
                .replace(`{${"forecastId"}}`, encodeURIComponent(String(forecastId)))
                .replace(`{${"thirdpartyVatNo"}}`, encodeURIComponent(String(thirdpartyVatNo)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update aka metadata and a number of calculation records
         * @param {ReductionInfo} [reductionInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReductionTarget: async (reductionInfo?: ReductionInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reductiontarget`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reductionInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reductionInfo !== undefined ? reductionInfo : {}) : (reductionInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update be category Id
         * @param {ReductionByCategory} [reductionByCategory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReductionTargetByCategory: async (reductionByCategory?: ReductionByCategory, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reductiontarget/byCategory`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof reductionByCategory !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reductionByCategory !== undefined ? reductionByCategory : {}) : (reductionByCategory || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReductionTargetApi - functional programming interface
 * @export
 */
export const ReductionTargetApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create aka metadata and a number of calculation records
         * @param {ReductionInfo} [reductionInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReductionTarget(reductionInfo?: ReductionInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReductionResult>> {
            const localVarAxiosArgs = await ReductionTargetApiAxiosParamCreator(configuration).createReductionTarget(reductionInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete
         * @param {number} reductionTargetId id of item to remove
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReductionTarget(reductionTargetId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ReductionTargetApiAxiosParamCreator(configuration).deleteReductionTarget(reductionTargetId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get selected and all categories for reduction target id
         * @param {number} reductionTargetId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(reductionTargetId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryInfo>>> {
            const localVarAxiosArgs = await ReductionTargetApiAxiosParamCreator(configuration).getCategories(reductionTargetId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get specific item
         * @param {number} reductionTargetId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReductionTarget(reductionTargetId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReductionResult>> {
            const localVarAxiosArgs = await ReductionTargetApiAxiosParamCreator(configuration).getReductionTarget(reductionTargetId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get specific item
         * @param {number} forecastId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReductionTargets(forecastId: number, thirdpartyVatNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReductionResults>> {
            const localVarAxiosArgs = await ReductionTargetApiAxiosParamCreator(configuration).getReductionTargets(forecastId, thirdpartyVatNo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary update aka metadata and a number of calculation records
         * @param {ReductionInfo} [reductionInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReductionTarget(reductionInfo?: ReductionInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReductionResult>> {
            const localVarAxiosArgs = await ReductionTargetApiAxiosParamCreator(configuration).updateReductionTarget(reductionInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary update be category Id
         * @param {ReductionByCategory} [reductionByCategory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReductionTargetByCategory(reductionByCategory?: ReductionByCategory, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReductionResultByCategory>> {
            const localVarAxiosArgs = await ReductionTargetApiAxiosParamCreator(configuration).updateReductionTargetByCategory(reductionByCategory, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ReductionTargetApi - factory interface
 * @export
 */
export const ReductionTargetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary create aka metadata and a number of calculation records
         * @param {ReductionInfo} [reductionInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReductionTarget(reductionInfo?: ReductionInfo, options?: any): AxiosPromise<ReductionResult> {
            return ReductionTargetApiFp(configuration).createReductionTarget(reductionInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete
         * @param {number} reductionTargetId id of item to remove
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReductionTarget(reductionTargetId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<string> {
            return ReductionTargetApiFp(configuration).deleteReductionTarget(reductionTargetId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get selected and all categories for reduction target id
         * @param {number} reductionTargetId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(reductionTargetId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<Array<CategoryInfo>> {
            return ReductionTargetApiFp(configuration).getCategories(reductionTargetId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get specific item
         * @param {number} reductionTargetId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReductionTarget(reductionTargetId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<ReductionResult> {
            return ReductionTargetApiFp(configuration).getReductionTarget(reductionTargetId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get specific item
         * @param {number} forecastId reduction target id
         * @param {string} thirdpartyVatNo if set use this when getting data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReductionTargets(forecastId: number, thirdpartyVatNo: string, options?: any): AxiosPromise<ReductionResults> {
            return ReductionTargetApiFp(configuration).getReductionTargets(forecastId, thirdpartyVatNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update aka metadata and a number of calculation records
         * @param {ReductionInfo} [reductionInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReductionTarget(reductionInfo?: ReductionInfo, options?: any): AxiosPromise<ReductionResult> {
            return ReductionTargetApiFp(configuration).updateReductionTarget(reductionInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update be category Id
         * @param {ReductionByCategory} [reductionByCategory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReductionTargetByCategory(reductionByCategory?: ReductionByCategory, options?: any): AxiosPromise<ReductionResultByCategory> {
            return ReductionTargetApiFp(configuration).updateReductionTargetByCategory(reductionByCategory, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReductionTargetApi - object-oriented interface
 * @export
 * @class ReductionTargetApi
 * @extends {BaseAPI}
 */
export class ReductionTargetApi extends BaseAPI {
    /**
     * 
     * @summary create aka metadata and a number of calculation records
     * @param {ReductionInfo} [reductionInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReductionTargetApi
     */
    public createReductionTarget(reductionInfo?: ReductionInfo, options?: any) {
        return ReductionTargetApiFp(this.configuration).createReductionTarget(reductionInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete
     * @param {number} reductionTargetId id of item to remove
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReductionTargetApi
     */
    public deleteReductionTarget(reductionTargetId: number, thirdpartyVatNo: string, options?: any) {
        return ReductionTargetApiFp(this.configuration).deleteReductionTarget(reductionTargetId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get selected and all categories for reduction target id
     * @param {number} reductionTargetId reduction target id
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReductionTargetApi
     */
    public getCategories(reductionTargetId: number, thirdpartyVatNo: string, options?: any) {
        return ReductionTargetApiFp(this.configuration).getCategories(reductionTargetId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get specific item
     * @param {number} reductionTargetId reduction target id
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReductionTargetApi
     */
    public getReductionTarget(reductionTargetId: number, thirdpartyVatNo: string, options?: any) {
        return ReductionTargetApiFp(this.configuration).getReductionTarget(reductionTargetId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get specific item
     * @param {number} forecastId reduction target id
     * @param {string} thirdpartyVatNo if set use this when getting data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReductionTargetApi
     */
    public getReductionTargets(forecastId: number, thirdpartyVatNo: string, options?: any) {
        return ReductionTargetApiFp(this.configuration).getReductionTargets(forecastId, thirdpartyVatNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update aka metadata and a number of calculation records
     * @param {ReductionInfo} [reductionInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReductionTargetApi
     */
    public updateReductionTarget(reductionInfo?: ReductionInfo, options?: any) {
        return ReductionTargetApiFp(this.configuration).updateReductionTarget(reductionInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update be category Id
     * @param {ReductionByCategory} [reductionByCategory] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReductionTargetApi
     */
    public updateReductionTargetByCategory(reductionByCategory?: ReductionByCategory, options?: any) {
        return ReductionTargetApiFp(this.configuration).updateReductionTargetByCategory(reductionByCategory, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RegexPatternsApi - axios parameter creator
 * @export
 */
export const RegexPatternsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation returns a list of all regex patterns
         * @summary A list of all regex patterns is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRegexPatterns: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/regexpatterns`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegexPatternsApi - functional programming interface
 * @export
 */
export const RegexPatternsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation returns a list of all regex patterns
         * @summary A list of all regex patterns is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchRegexPatterns(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegexPatterns>> {
            const localVarAxiosArgs = await RegexPatternsApiAxiosParamCreator(configuration).fetchRegexPatterns(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RegexPatternsApi - factory interface
 * @export
 */
export const RegexPatternsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This operation returns a list of all regex patterns
         * @summary A list of all regex patterns is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRegexPatterns(options?: any): AxiosPromise<RegexPatterns> {
            return RegexPatternsApiFp(configuration).fetchRegexPatterns(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegexPatternsApi - object-oriented interface
 * @export
 * @class RegexPatternsApi
 * @extends {BaseAPI}
 */
export class RegexPatternsApi extends BaseAPI {
    /**
     * This operation returns a list of all regex patterns
     * @summary A list of all regex patterns is returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegexPatternsApi
     */
    public fetchRegexPatterns(options?: any) {
        return RegexPatternsApiFp(this.configuration).fetchRegexPatterns(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SessionApi - axios parameter creator
 * @export
 */
export const SessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/session/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionApi - functional programming interface
 * @export
 */
export const SessionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await SessionApiAxiosParamCreator(configuration).logout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SessionApi - factory interface
 * @export
 */
export const SessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<string> {
            return SessionApiFp(configuration).logout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionApi - object-oriented interface
 * @export
 * @class SessionApi
 * @extends {BaseAPI}
 */
export class SessionApi extends BaseAPI {
    /**
     * 
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public logout(options?: any) {
        return SessionApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * StatisticsApi - axios parameter creator
 * @export
 */
export const StatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get List af statistics
         * @summary Get List af statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/statistics/get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsApi - functional programming interface
 * @export
 */
export const StatisticsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get List af statistics
         * @summary Get List af statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatistics(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Statistic>>> {
            const localVarAxiosArgs = await StatisticsApiAxiosParamCreator(configuration).getStatistics(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StatisticsApi - factory interface
 * @export
 */
export const StatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get List af statistics
         * @summary Get List af statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics(options?: any): AxiosPromise<Array<Statistic>> {
            return StatisticsApiFp(configuration).getStatistics(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsApi - object-oriented interface
 * @export
 * @class StatisticsApi
 * @extends {BaseAPI}
 */
export class StatisticsApi extends BaseAPI {
    /**
     * Get List af statistics
     * @summary Get List af statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getStatistics(options?: any) {
        return StatisticsApiFp(this.configuration).getStatistics(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TestContextApi - axios parameter creator
 * @export
 */
export const TestContextApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retreives Info on used EMC
         * @param {TestContextRequest} [testContextRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssertionContext: async (testContextRequest?: TestContextRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/test/context`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof testContextRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(testContextRequest !== undefined ? testContextRequest : {}) : (testContextRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a forecast for testpurposes
         * @param {TestContextCreateForecastRequest} [testContextCreateForecastRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestForecast: async (testContextCreateForecastRequest?: TestContextCreateForecastRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/test/context/forecast`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof testContextCreateForecastRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(testContextCreateForecastRequest !== undefined ? testContextCreateForecastRequest : {}) : (testContextCreateForecastRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestContextApi - functional programming interface
 * @export
 */
export const TestContextApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retreives Info on used EMC
         * @param {TestContextRequest} [testContextRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssertionContext(testContextRequest?: TestContextRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await TestContextApiAxiosParamCreator(configuration).createAssertionContext(testContextRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Creates a forecast for testpurposes
         * @param {TestContextCreateForecastRequest} [testContextCreateForecastRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestForecast(testContextCreateForecastRequest?: TestContextCreateForecastRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await TestContextApiAxiosParamCreator(configuration).createTestForecast(testContextCreateForecastRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TestContextApi - factory interface
 * @export
 */
export const TestContextApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Retreives Info on used EMC
         * @param {TestContextRequest} [testContextRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssertionContext(testContextRequest?: TestContextRequest, options?: any): AxiosPromise<string> {
            return TestContextApiFp(configuration).createAssertionContext(testContextRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a forecast for testpurposes
         * @param {TestContextCreateForecastRequest} [testContextCreateForecastRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestForecast(testContextCreateForecastRequest?: TestContextCreateForecastRequest, options?: any): AxiosPromise<string> {
            return TestContextApiFp(configuration).createTestForecast(testContextCreateForecastRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestContextApi - object-oriented interface
 * @export
 * @class TestContextApi
 * @extends {BaseAPI}
 */
export class TestContextApi extends BaseAPI {
    /**
     * 
     * @summary Retreives Info on used EMC
     * @param {TestContextRequest} [testContextRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestContextApi
     */
    public createAssertionContext(testContextRequest?: TestContextRequest, options?: any) {
        return TestContextApiFp(this.configuration).createAssertionContext(testContextRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a forecast for testpurposes
     * @param {TestContextCreateForecastRequest} [testContextCreateForecastRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestContextApi
     */
    public createTestForecast(testContextCreateForecastRequest?: TestContextCreateForecastRequest, options?: any) {
        return TestContextApiFp(this.configuration).createTestForecast(testContextCreateForecastRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ThirdpartyApi - axios parameter creator
 * @export
 */
export const ThirdpartyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a third party access to a calculation
         * @param {AccessInfo} [accessInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccess: async (accessInfo?: AccessInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/thirdparty`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof accessInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(accessInfo !== undefined ? accessInfo : {}) : (accessInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Access
         * @param {number} id id of third party to remove access for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccess: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAccess.');
            }
            const localVarPath = `/v1/thirdparty/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary virk A delete the individual 3. part request for acccess
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndividualAccess: async (accessIndividualId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessIndividualId' is not null or undefined
            if (accessIndividualId === null || accessIndividualId === undefined) {
                throw new RequiredError('accessIndividualId','Required parameter accessIndividualId was null or undefined when calling deleteIndividualAccess.');
            }
            const localVarPath = `/v1/thirdparty/step2/delete/{accessIndividualId}`
                .replace(`{${"accessIndividualId"}}`, encodeURIComponent(String(accessIndividualId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get list of all access that has been granted for logged in user\'s vatnr
         * @param {string} vatId vatId of current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccess: async (vatId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling getAccess.');
            }
            const localVarPath = `/v1/thirdparty/{vatId}`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get list of all access that I have been given from someone else
         * @param {string} vatId vatId of current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGivenAccess: async (vatId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling getGivenAccess.');
            }
            const localVarPath = `/v1/thirdparty/given/{vatId}`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Virk A accept the 3. part request for access
         * @summary accept 3. part request for acccess
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantIndividualAccess: async (accessIndividualId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessIndividualId' is not null or undefined
            if (accessIndividualId === null || accessIndividualId === undefined) {
                throw new RequiredError('accessIndividualId','Required parameter accessIndividualId was null or undefined when calling grantIndividualAccess.');
            }
            const localVarPath = `/v1/thirdparty/step2/grant/{accessIndividualId}`
                .replace(`{${"accessIndividualId"}}`, encodeURIComponent(String(accessIndividualId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary virk A rejects the individual 3. part request for acccess (but items is not delete only changed status)
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectIndividualAccess: async (accessIndividualId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessIndividualId' is not null or undefined
            if (accessIndividualId === null || accessIndividualId === undefined) {
                throw new RequiredError('accessIndividualId','Required parameter accessIndividualId was null or undefined when calling rejectIndividualAccess.');
            }
            const localVarPath = `/v1/thirdparty/step2/reject/{accessIndividualId}`
                .replace(`{${"accessIndividualId"}}`, encodeURIComponent(String(accessIndividualId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 3. part send step2 request for access
         * @param {RequestIndividualInfo} [requestIndividualInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestIndividualAccess: async (requestIndividualInfo?: RequestIndividualInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/thirdparty/step2/3part`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestIndividualInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestIndividualInfo !== undefined ? requestIndividualInfo : {}) : (requestIndividualInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary as third party revoke access
         * @param {number} id id of third party to remove access for
         * @param {number} individualAccessId id of specific cpr third party user to remove access for - can be null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccess: async (id: number, individualAccessId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling revokeAccess.');
            }
            // verify required parameter 'individualAccessId' is not null or undefined
            if (individualAccessId === null || individualAccessId === undefined) {
                throw new RequiredError('individualAccessId','Required parameter individualAccessId was null or undefined when calling revokeAccess.');
            }
            const localVarPath = `/v1/thirdparty/revoke/{id}/{individualAccessId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"individualAccessId"}}`, encodeURIComponent(String(individualAccessId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates access info
         * @param {AccessInfo} [accessInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccess: async (accessInfo?: AccessInfo, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/thirdparty`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof accessInfo !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(accessInfo !== undefined ? accessInfo : {}) : (accessInfo || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThirdpartyApi - functional programming interface
 * @export
 */
export const ThirdpartyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a third party access to a calculation
         * @param {AccessInfo} [accessInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccess(accessInfo?: AccessInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessInfo>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).createAccess(accessInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete Access
         * @param {number} id id of third party to remove access for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccess(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).deleteAccess(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary virk A delete the individual 3. part request for acccess
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIndividualAccess(accessIndividualId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessInfo>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).deleteIndividualAccess(accessIndividualId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get list of all access that has been granted for logged in user\'s vatnr
         * @param {string} vatId vatId of current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccess(vatId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessInfo>>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).getAccess(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get list of all access that I have been given from someone else
         * @param {string} vatId vatId of current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGivenAccess(vatId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessInfo>>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).getGivenAccess(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Virk A accept the 3. part request for access
         * @summary accept 3. part request for acccess
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantIndividualAccess(accessIndividualId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessInfo>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).grantIndividualAccess(accessIndividualId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary virk A rejects the individual 3. part request for acccess (but items is not delete only changed status)
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectIndividualAccess(accessIndividualId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessInfo>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).rejectIndividualAccess(accessIndividualId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 3. part send step2 request for access
         * @param {RequestIndividualInfo} [requestIndividualInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestIndividualAccess(requestIndividualInfo?: RequestIndividualInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessInfo>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).requestIndividualAccess(requestIndividualInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary as third party revoke access
         * @param {number} id id of third party to remove access for
         * @param {number} individualAccessId id of specific cpr third party user to remove access for - can be null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAccess(id: number, individualAccessId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessInfo>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).revokeAccess(id, individualAccessId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates access info
         * @param {AccessInfo} [accessInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccess(accessInfo?: AccessInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessInfo>> {
            const localVarAxiosArgs = await ThirdpartyApiAxiosParamCreator(configuration).updateAccess(accessInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ThirdpartyApi - factory interface
 * @export
 */
export const ThirdpartyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary create a third party access to a calculation
         * @param {AccessInfo} [accessInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccess(accessInfo?: AccessInfo, options?: any): AxiosPromise<AccessInfo> {
            return ThirdpartyApiFp(configuration).createAccess(accessInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Access
         * @param {number} id id of third party to remove access for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccess(id: number, options?: any): AxiosPromise<string> {
            return ThirdpartyApiFp(configuration).deleteAccess(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary virk A delete the individual 3. part request for acccess
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndividualAccess(accessIndividualId: number, options?: any): AxiosPromise<AccessInfo> {
            return ThirdpartyApiFp(configuration).deleteIndividualAccess(accessIndividualId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get list of all access that has been granted for logged in user\'s vatnr
         * @param {string} vatId vatId of current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccess(vatId: string, options?: any): AxiosPromise<Array<AccessInfo>> {
            return ThirdpartyApiFp(configuration).getAccess(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get list of all access that I have been given from someone else
         * @param {string} vatId vatId of current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGivenAccess(vatId: string, options?: any): AxiosPromise<Array<AccessInfo>> {
            return ThirdpartyApiFp(configuration).getGivenAccess(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Virk A accept the 3. part request for access
         * @summary accept 3. part request for acccess
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantIndividualAccess(accessIndividualId: number, options?: any): AxiosPromise<AccessInfo> {
            return ThirdpartyApiFp(configuration).grantIndividualAccess(accessIndividualId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary virk A rejects the individual 3. part request for acccess (but items is not delete only changed status)
         * @param {number} accessIndividualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectIndividualAccess(accessIndividualId: number, options?: any): AxiosPromise<AccessInfo> {
            return ThirdpartyApiFp(configuration).rejectIndividualAccess(accessIndividualId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 3. part send step2 request for access
         * @param {RequestIndividualInfo} [requestIndividualInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestIndividualAccess(requestIndividualInfo?: RequestIndividualInfo, options?: any): AxiosPromise<AccessInfo> {
            return ThirdpartyApiFp(configuration).requestIndividualAccess(requestIndividualInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary as third party revoke access
         * @param {number} id id of third party to remove access for
         * @param {number} individualAccessId id of specific cpr third party user to remove access for - can be null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccess(id: number, individualAccessId: number, options?: any): AxiosPromise<AccessInfo> {
            return ThirdpartyApiFp(configuration).revokeAccess(id, individualAccessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates access info
         * @param {AccessInfo} [accessInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccess(accessInfo?: AccessInfo, options?: any): AxiosPromise<AccessInfo> {
            return ThirdpartyApiFp(configuration).updateAccess(accessInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThirdpartyApi - object-oriented interface
 * @export
 * @class ThirdpartyApi
 * @extends {BaseAPI}
 */
export class ThirdpartyApi extends BaseAPI {
    /**
     * 
     * @summary create a third party access to a calculation
     * @param {AccessInfo} [accessInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public createAccess(accessInfo?: AccessInfo, options?: any) {
        return ThirdpartyApiFp(this.configuration).createAccess(accessInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Access
     * @param {number} id id of third party to remove access for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public deleteAccess(id: number, options?: any) {
        return ThirdpartyApiFp(this.configuration).deleteAccess(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary virk A delete the individual 3. part request for acccess
     * @param {number} accessIndividualId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public deleteIndividualAccess(accessIndividualId: number, options?: any) {
        return ThirdpartyApiFp(this.configuration).deleteIndividualAccess(accessIndividualId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get list of all access that has been granted for logged in user\'s vatnr
     * @param {string} vatId vatId of current logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public getAccess(vatId: string, options?: any) {
        return ThirdpartyApiFp(this.configuration).getAccess(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get list of all access that I have been given from someone else
     * @param {string} vatId vatId of current logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public getGivenAccess(vatId: string, options?: any) {
        return ThirdpartyApiFp(this.configuration).getGivenAccess(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Virk A accept the 3. part request for access
     * @summary accept 3. part request for acccess
     * @param {number} accessIndividualId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public grantIndividualAccess(accessIndividualId: number, options?: any) {
        return ThirdpartyApiFp(this.configuration).grantIndividualAccess(accessIndividualId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary virk A rejects the individual 3. part request for acccess (but items is not delete only changed status)
     * @param {number} accessIndividualId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public rejectIndividualAccess(accessIndividualId: number, options?: any) {
        return ThirdpartyApiFp(this.configuration).rejectIndividualAccess(accessIndividualId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 3. part send step2 request for access
     * @param {RequestIndividualInfo} [requestIndividualInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public requestIndividualAccess(requestIndividualInfo?: RequestIndividualInfo, options?: any) {
        return ThirdpartyApiFp(this.configuration).requestIndividualAccess(requestIndividualInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary as third party revoke access
     * @param {number} id id of third party to remove access for
     * @param {number} individualAccessId id of specific cpr third party user to remove access for - can be null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public revokeAccess(id: number, individualAccessId: number, options?: any) {
        return ThirdpartyApiFp(this.configuration).revokeAccess(id, individualAccessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates access info
     * @param {AccessInfo} [accessInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdpartyApi
     */
    public updateAccess(accessInfo?: AccessInfo, options?: any) {
        return ThirdpartyApiFp(this.configuration).updateAccess(accessInfo, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * VersionsApi - axios parameter creator
 * @export
 */
export const VersionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the years of Emission Coefficients objects
         * @summary Returns all years and versions Emission Coefficients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllVersions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/versionsAll`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the years of Emission Coefficients objects
         * @summary Returns all years with max versions for Emission Coefficients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVersions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/versions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionsApi - functional programming interface
 * @export
 */
export const VersionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Retrieves the years of Emission Coefficients objects
         * @summary Returns all years and versions Emission Coefficients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllVersions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Versions>> {
            const localVarAxiosArgs = await VersionsApiAxiosParamCreator(configuration).fetchAllVersions(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the years of Emission Coefficients objects
         * @summary Returns all years with max versions for Emission Coefficients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchVersions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Versions>> {
            const localVarAxiosArgs = await VersionsApiAxiosParamCreator(configuration).fetchVersions(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * VersionsApi - factory interface
 * @export
 */
export const VersionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Retrieves the years of Emission Coefficients objects
         * @summary Returns all years and versions Emission Coefficients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllVersions(options?: any): AxiosPromise<Versions> {
            return VersionsApiFp(configuration).fetchAllVersions(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the years of Emission Coefficients objects
         * @summary Returns all years with max versions for Emission Coefficients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVersions(options?: any): AxiosPromise<Versions> {
            return VersionsApiFp(configuration).fetchVersions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionsApi - object-oriented interface
 * @export
 * @class VersionsApi
 * @extends {BaseAPI}
 */
export class VersionsApi extends BaseAPI {
    /**
     * Retrieves the years of Emission Coefficients objects
     * @summary Returns all years and versions Emission Coefficients.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    public fetchAllVersions(options?: any) {
        return VersionsApiFp(this.configuration).fetchAllVersions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the years of Emission Coefficients objects
     * @summary Returns all years with max versions for Emission Coefficients.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    public fetchVersions(options?: any) {
        return VersionsApiFp(this.configuration).fetchVersions(options).then((request) => request(this.axios, this.basePath));
    }

}


